const gearCards = [

/*

    {
        "name": "Temp",
        "keywords": "temp",
        "numbers": null,
        "description": "temp",
        "affinity": "temp",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": "temp",
        "armourPoints": 1,
        "craftLocation": "temp",
        "expansion": "core",
    },
    {
        "name": "Temp",
        "keywords": "temp",
        "numbers": [],
        "description": "temp",
        "affinity": "temp",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "temp",
        "expansion": "core",
    },

*/    



    {
        "name": "Fist & Tooth",
        "keywords": "weapon, melee, fist & tooth",
        "numbers": [2, 8, 0],
        "description": "Deadly: +1 luck when you attach with this weapon",
        "affinity": null,
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "default",
        "expansion": "core",
    },
    {
        "name": "Founding Stone",
        "keywords": "weapon, melee, stone",
        "numbers": [2, 7, 1],
        "description": "Spend Activation to sling the stone from anywhere on the board! Archive this card for 1 automatic hit that inflicts a critical wound. Archive: Return the card to the game box.",
        "affinity": null,
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "starting",
        "expansion": "core",
    },
    {
        "name": "Cloth",
        "keywords": "armor",
        "numbers": null,
        "description": "The Cloth protects your waist. Gain 1 armor point at the waist hit location",
        "affinity": null,
        "bodyPart": "waist",
        "armourPoints": 1,
        "craftLocation": "starting",
        "expansion": "core",
    },
    {
        "name": "Rawhide Headband",
        "keywords": "armor, set, rawhide",
        "numbers": null,
        "desciption": null,
        "affinityDescription": "bluePuzzleActivationReveal the top 2 aiCard Place them back on top of the deck in any order.",
        "affinity": "blank, blank, blue, blank, blank",
        "bodyPart": "head",
        "armourPoints": 1,
        "craftLocation": "skinnery",
        "expansion": "core",
    },
    {
        "name": "Rawhide Gloves",
        "keywords": "armor, set, rawhide",
        "numbers": null,
        "description": "When you depart, gain +1 survival.",
        "affinity": "blank, blank, blank, red, blank",
        "bodyPart": "arms",
        "armourPoints": 1,
        "craftLocation": "skinnery",
        "expansion": "core",
    },
    {
        "name": "Rawhide Vest",
        "keywords": "armor, set, rawhide",
        "numbers": null,
        "description": null,
        "affinityDescription": "bluePuzzleredPuzzle+1 evasion",
        "affinity": null,
        "bodyPart": "body",
        "armourPoints": 1,
        "craftLocation": "skinnery",
        "expansion": "core",
    },
    {
        "name": "Rawhide Pants",
        "keywords": "armor, set, rawhide",
        "numbers": null,
        "description": null,
        "affinity": null,
        "bodyPart": "waist",
        "armourPoints": 1,
        "craftLocation": "skinnery",
        "expansion": "core",
    },
    {
        "name": "Rawhide Boots",
        "keywords": "armor, set, rawhide",
        "numbers": null,
        "description": "When you depart, gain +1 survival.",
        "affinity": null,
        "bodyPart": "legs",
        "armourPoints": 1,
        "craftLocation": "skinnery",
        "expansion": "core",
    },
    {
        "name": "Bandages",
        "keywords": "item",
        "numbers": null,
        "description": "Activation: Remove up to 2 bleeding tokens from yourself or an adjacent survivor.",
        "affinity": "blank, blank, green, blue, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "skinnery",
        "expansion": "core",
    },
    {
        "name": "Rawhide Whip",
        "keywords": "weapon, melee, whip, rawhide",
        "numbers": "3, 7, 1",
        "description": "Provoke: When you wound with this weapon, gain the Priority Target token.",
        "affinity": null,
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "skinnery",
        "expansion": "core",
    },
    {
        "name": "Rawhide Drum",
        "keywords": "item, rawhide, instrument, noisy",
        "numbers": null,
        "description": "On Arrival, all survivors gain +1 insanity. Inspirational Drumming! When you perform encourage, all non-deaf survivors are affected.",
        "affinity": null,
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "skinnery",
        "expansion": "core",
    },
    {
        "name": "Dried Acanthus",
        "keywords": "item, herb, consumable",
        "numbers": null,
        "description": "When you depart, gain +2 survival. When you suffer a severe injury, ignore it and archive this card instead",
        "affinity": null,
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "organGrinder",
        "expansion": "core",
    },
    {
        "name": "Fecal Salve",
        "keywords": "item, balm, stinky",
        "numbers": null,
        "description": "When you depart, gain +1 survival.\nActivation: You are not a threat until you attack. If you have the priority target token, remove it.",
        "affinity": "blank, blank, blank, blue, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "organGrinder",
        "expansion": "core",
    },
    {
        "name": "Lucky Charm",
        "keywords": "item, jewelry",
        "numbers": null,
        "affinityDescription": "blueBoxblueBox+1 luck",
        "affinity": "blank, blue, blank, blue, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "organGrinder",
        "expansion": "core",
    },
    {
        "name": "Monster Grease",
        "keywords": "item, consumable, soluble, stinky, flammable",
        "numbers": null,
        "description": "Gain +1 evasion.",
        "affinityDescription": "greenBoxgreenBoxgreenBox+1 evasion",
        "affinity": "blank, blank, blank, green, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "organGrinder",
        "expansion": "core",
    },
    {
        "name": "Monster Tooth Necklace",
        "keywords": "item, jewelry, bone",
        "numbers": null,
        "description": "Gain +1 strength.",
        "affinityDescription": "redBoxredBox+1 strength",
        "affinity": "blank, red, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "organGrinder",
        "expansion": "core",
    },
    {
        "name": "Bone Axe",
        "keywords": "weapon, melee, axe, bone",
        "numbers": [2, 6, 3],
        "description": "Frail\nSavage: Once per attack, if you critically wound, cause 1 additional wound. This effect does not apply to impervious hit locations.",
        "affinity": "blank, blank, blank, red, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "boneSmith",
        "expansion": "core",
    },
    {
        "name": "Bone Blade",
        "keywords": "weapon, melee, sword, bone",
        "numbers": [2, 6, 2],
        "description": "Frail: When you attempt to wound a super-dense hit location, this weapon breaks.\nArchive this card at the end of the attack.",
        "affinity": "blank, blank, blank, red, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "boneSmith",
        "expansion": "core",
    },
    {
        "name": "Bone Club",
        "keywords": "weapon, melee, two-handed, heavy, club, bone",
        "numbers": [2, 6, 5],
        "description": "Cumbersome: Spend Movement as an additional cost to activate this weapon. Ignore Cumbersome if this weapon is activated indirectly (Pounce, Charge, etc).",
        "affinity": "blank, red, blank, red, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "boneSmith",
        "expansion": "core",
    },
    {
        "name": "Bone Dagger",
        "keywords": "weapon, melee, dagger, bone",
        "numbers": [3, 7, 1],
        "description": "On a Perfect hit, gain +1 survival.\nPerfect hit: An attack roll result of a lantern 10.",
        "affinity": "red, blank, blank, red, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "boneSmith",
        "expansion": "core",
    },
    {
        "name": "Bone Darts",
        "keywords": "weapon, ranged, thrown, bone",
        "numbers": [1, 7, 3],
        "description": "Range: 6.\nFrail: When you attempt to wound a super-dense hit location, this weapon breaks.\nArchive this card at the end of the attack.",
        "affinity": "blank, blank, blank, red, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "boneSmith",
        "expansion": "core",
    },
    {
        "name": "Bone Pickaxe",
        "keywords": "item, tool, pickaxe, bone",
        "numbers": [1, 8, 2],
        "description": "After Hunt phase setup, place the Mineral Gathering event on any hunt space.",
        "affinity": "green, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "boneSmith",
        "expansion": "core",
    },
    {
        "name": "Bone Sickle",
        "keywords": "item, tool, sickle, bone",
        "numbers": [2, 8, 2],
        "description": "After Hunt phase setup, place Herb Gathering evbent on any hunt space.",
        "affinity": "green, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "boneSmith",
        "expansion": "core",
    },
    {
        "name": "Skull Helm",
        "keywords": "armor, bone, fragile",
        "numbers": null,
        "description": "When you suffer a severe head injury, the Skull Helm is destroyed. Archive this card.",
        "affinity": "blank, blank, red, blank, blank",
        "bodyPart": "head",
        "armourPoints": 3,
        "craftLocation": "boneSmith",
        "expansion": "core",
    },
    {
        "name": "Alamanac",
        "keywords": "item, soluble, flammable",
        "numbers": null,
        "description": "When you depart, gain +2 insanity.\nYou cannot gain disorders.",
        "affinity": "blank, blue, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "barberSurgeon",
        "expansion": "core",
    },
    {
        "name": "Blue Charm",
        "keywords": "item, jewelry, fragile",
        "numbers": null,
        "affinityDescription": "blueBoxblueBoxblueBoxblueBoxblueBoxUnshakeable: When you draw a Trap, roll 1d10.\nOn a 6+, discard the Trap and reshuffle the deck.",
        "affinity": "blank, blank, blank, blank, blue",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "barberSurgeon",
        "expansion": "core",
    },
    {
        "name": "Green Charm",
        "keywords": "item, jewelry, fragile",
        "numbers": null,
        "affinityDescription": "greenBoxgreenBoxgreenBoxgreenBoxgreenBoxUndeathable: If you would die, roll 1d10.\nOn a 6+, you inexplicably survive.",
        "affinity": "blank, blank, blank, blank, green",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "barberSurgeon",
        "expansion": "core",
    },
    {
        "name": "Red Charm",
        "keywords": "item, jewelry, fragile",
        "numbers": null,
        "affinityDescription": "redBoxredBoxredBoxredBoxredBoxUnstoppable: When you attempt to would, instead roll 1d10. On 1-5, fail. On 6-10, wound.",
        "affinity": "blank, blank, blank, blank, red",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "barberSurgeon",
        "expansion": "core",
    },
    {
        "name": "Bug Trap",
        "keywords": "item, soluble",
        "numbers": null,
        "description": "At the start of the showdown, roll 1d10. On a 3+, add a Bug Patch terrain card to the showdown board",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "barberSurgeon",
        "expansion": "core",
    },
    {
        "name": "First Aid Kit",
        "keywords": "item, heavy",
        "numbers": null,
        "description": "On Arrival, all survivors gain +3 survival.\nActivation: Remove 1 bleeding or negative attribute token from yourself or an adjacent survivor.",
        "affinity": "green, green, green, green, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "barberSurgeon",
        "expansion": "core",
    },
    {
        "name": "Musk Bomb",
        "keywords": "item, stinky, thrown, fragile",
        "numbers": null,
        "description": "If Adjacent to the monster when it draws aiCard, you may spend 2 survival and archive Musk bomb to roll 1d10. On a 3+, discard aiCard without playing it.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "barberSurgeon",
        "expansion": "core",
    },
    {
        "name": "Scavenger Kit",
        "keywords": "item, heavy",
        "numbers": null,
        "description": "Unique\nWhen you defeat a monster, gain either 1 random basic resource or 1 random monster resource from that monster's resource deck.",
        "affinity": "blank, blank, green, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "barberSurgeon",
        "expansion": "core",
    },
    {
        "name": "Leather Mask",
        "keywords": "armor, set, leather",
        "numbers": null,
        "description": "When you depart, gain +2 insanity.",
        "affinity": "blue, blank, red, blank, blank",
        "bodyPart": "head",
        "armourPoints": 3,
        "craftLocation": "leatherWorker",
        "expansion": "core",
    },
    {
        "name": "Leather Bracers",
        "keywords": "armor, set, leather",
        "numbers": null,
        "description": "When you depart, gain +2 survival.",
        "affinity": "blank, green, blank, blank, blank",
        "bodyPart": "arms",
        "armourPoints": 3,
        "craftLocation": "leatherWorker",
        "expansion": "core",
    },
    {
        "name": "Leather Cuirass",
        "keywords": "armor, set, leather",
        "numbers": null,
        "description": null,
        "affinity": "red, blank, blue, blank, blank",
        "bodyPart": "body",
        "armourPoints": 3,
        "craftLocation": "leatherWorker",
        "expansion": "core",
    },
    {
        "name": "Leather Skirt",
        "keywords": "armor, set, leather",
        "numbers": null,
        "description": null,
        "affinity": "blank, blank, green, blank, blank",
        "bodyPart": "waist",
        "armourPoints": 3,
        "craftLocation": "leatherWorker",
        "expansion": "core",
    },
    {
        "name": "Leather Boots",
        "keywords": "armor, set, leather",
        "numbers": null,
        "affinityDescription": "greenPuzzlegreenPuzzleAt the end of your act, you may move 1 space.",
        "affinity": "blank, green, blank, green, blank",
        "bodyPart": "legs",
        "armourPoints": 3,
        "craftLocation": "leatherWorker",
        "expansion": "core",
    },
    {
        "name": "Hunter Whip",
        "keywords": "weapon, melee, whip, leather",
        "numbers": [3, 6, 3],
        "affinityDescription": "bluePuzzlebluePuzzleOn a Perfect Hit, discard 1 mood in play.",
        "affinity": "blue, blue, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "leatherWorker",
        "expansion": "core",
    },
    {
        "name": "Round Leather Shield",
        "keywords": "weapon, melee, shield, leather",
        "numbers": [1, 8, 1],
        "description": "Add 1 Armour Point to all the hit locations.\nBlock 1: Spend Activation to ignore 1 hit the next time you are attacked. Lasts until your next act. "+
                       "You cannot use block more than once per attack.",
        "affinity": "green, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "leatherWorker",
        "expansion": "core",
    },
    {
        "name": "Cat Eye Circlet",
        "keywords": "item, jewelry, other",
        "numbers": null,
        "description": "Activation: Reveal the next 3 monster hit locations and put them back in any order.",
        "affinity": "blank, blank, blank, blue, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "catarium,",
        "expansion": "core, whiteLion",
    },
    {
        "name": "Cat Fang Knife",
        "keywords": "weapon, melee, dagger, bone",
        "numbers": [3, 6, 2],
        "affinityDescription": "redBoxredBoxredBoxOn a Perfect hit, gain +1 strength token. When you are knocked down, remove all your +1 strength tokens.",
        "affinity": "red, red, red, red, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "catarium",
        "expansion": "core, whiteLion",
    },
    {
        "name": "Cat Gut Bow",
        "keywords": "weapon, ranged, bow, two-handed",
        "numbers": [2, 7, 3],
        "description": "Cumbersome, Range 6\nAim: When you attack, before rolling to hit, you may reduce the speed of this weapon by 1 to gain +2 accuracy for that attack.",
        "affinity": "blue, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "catarium",
        "expansion": "core, whiteLion",
    },
    {
        "name": "Cat Head Arrow",
        "keywords": "item, ammunition, arrow",
        "numbers": [1, 6, 6],
        "description": "Slow, Ammo - Bow: You must have a bow in your gear grid to activate this.\nIf you hit, monster gains -1 evasion token. Use once per showdown.",
        "affinity": "blank, blank, blue, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "catarium",
        "expansion": "core, whiteLion",
    },
    {
        "name": "Frenzy Drink",
        "keywords": "item, consumable, fragile",
        "numbers": null,
        "description": "Activation Consume: Suffer Frenzy brain trauma. Can be used once per showdown.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "catarium",
        "expansion": "core, whiteLion",
    },
    {
        "name": "King Spear",
        "keywords": "weapon, melee, spear, heavy, two-handed",
        "numbers": [2, 6, 3],
        "description": "Reach 2: May attack from 2 spaces away",
        "affinity": "blank, red, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "catarium",
        "expansion": "core, whiteLion",
    },
    {
        "name": "Lion Beast Katar",
        "keywords": "weapon, melee, katar",
        "numbers": [2, 7, 3],
        "description": "Deadly: +1 luck with this weapon.\nPaired: When you attack, add the speed of a 2nd Lion Beast Katar in your gear grid.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "catarium",
        "expansion": "core, whiteLion",
    },
    {
        "name": "Lion Headdress",
        "keywords": "item, flammable",
        "numbers": null,
        "description": "Accessory: You may wear this in addition to 1 armor at this location.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": "head",
        "armourPoints": 1,
        "craftLocation": "catarium",
        "expansion": "core, whiteLion",
    },
    {
        "name": "Lion Skin Cloak",
        "keywords": "armor, fur, heavy, bone, flammable",
        "numbers": null,
        "description": "Reduce damage from every hit suffered by 1 to a minimum of 1.",
        "affinity": "blank, blank, green, blank, blank",
        "bodyPart": "body",
        "armourPoints": 0,
        "craftLocation": "catarium",
        "expansion": "core, whiteLion",
    },
    {
        "name": "Whisker Harp",
        "keywords": "item, instrument, noisy",
        "numbers": null,
        "description": "On Arrival, all survivors gain +1 survival.\nActivation: Strum. Roll 1d10. On a result of 6+ discard 1 mood currently in play.",
        "affinity": "blank, blank, blank, blue, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "catarium",
        "expansion": "core, whiteLion",
    },
    {
        "name": "White Lion Helm",
        "keywords": "armor, set, fur, heavy",
        "numbers": null,
        "affinityDescription": "redPuzzleblueBoxActivation and 1 survival: Roar, Non-Deaf Insane survivors gain +2 strength until end of round. All other survivors gain +1 insanity",
        "affinity": "blank, blank, red, blank, blank",
        "bodyPart": "head",
        "armourPoints": 2,
        "craftLocation": "catarium",
        "expansion": "core, whiteLion",
    },
    {
        "name": "White Lion Gauntlets",
        "keywords": "armor, set, fur, heavy",
        "numbers": null,
        "description": "When you Pounce, gain +1 accuracy for your next attack this turn.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": "arms",
        "armourPoints": 2,
        "craftLocation": "catarium",
        "expansion": "core, whiteLion",
    },
    {
        "name": "White Lion Coat",
        "keywords": "armor, set, fur, heavy",
        "numbers": null,
        "description": "Pounce: Spend Movement and Activation to move 3 spaces in a straight line. Then, if you moved 3 spaces, activate a melee weapon with +1 strength.",
        "affinity": "blue, blank, blank, blank, blank",
        "bodyPart": "body",
        "armourPoints": 2,
        "craftLocation": "catarium",
        "expansion": "core, whiteLion",
    },
    {
        "name": "White Lion Skirt",
        "keywords": "armor, set, fur, heavy",
        "numbers": null,
        "description": null,
        "affinity": "blank, red, blank, red, blank",
        "bodyPart": "waist",
        "armourPoints": 2,
        "craftLocation": "catarium",
        "expansion": "core, whiteLion",
    },
    {
        "name": "White Lion Boots",
        "keywords": "armor, set, fur, heavy",
        "numbers": null,
        "affinityDescription": "redPuzzleredPuzzle+1 movement",
        "affinity": "blank, red, red, blank, blank",
        "bodyPart": "legs",
        "armourPoints": 2,
        "craftLocation": "catarium",
        "expansion": "core, whiteLion",
    },
    {
        "name": "Beacon Shield",
        "keywords": "weapon, melee, shield, metal, heavy",
        "numbers": [1, 6, 5],
        "description": "Add 2 to all hit locations.\nBlock 2: Spend Activation to ignore 2 hits the next time you are attacked. Lasts until your next act. "+
                       "You cannot use block more than once per attack.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "blacksmith",
        "expansion": "core",
    },
    {
        "name": "Dragon Slayer",
        "keywords": "weapon, melee, grand weapon, two-handed, heavy, metal",
        "numbers": [1, 6, 9],
        "description": "Frail, Slow, Sharp, Devastating 1\nEarly Iron: When an attack roll result is 1, cancel any hits and end the attack.",
        "affinity": "blue, red, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "blacksmith",
        "expansion": "core",
    },
    {
        "name": "Lantern Dagger",
        "keywords": "weapon, melee, dagger, finesse, metal",
        "numbers": [2, 7, 1],
        "description": "Paired\nSharp: Add 1d10 Strength to each wound attempt.\nEarly Iron: When an attack roll result is 1, cancel any hits and end the attack.",
        "affinity": "blank, blank, blank, red, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "blacksmith",
        "expansion": "core",
    },
    {
        "name": "Lantern Glaive",
        "keywords": "weapon, melee, spear, axe, two-handed, finesse, metal",
        "numbers": [2, 6, 4],
        "description": "Reach 2\nSharp: Add 1d10 Strength to each wound attempt.\nEarly Iron: When an attack roll result is 1, cancel any hits and end the attack.",
        "affinity": "blank, blank, green, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "blacksmith",
        "expansion": "core",
    },
    {
        "name": "Lantern Helm",
        "keywords": "armor, set, metal, heavy",
        "numbers": null,
        "affinityDescription": "bluePuzzle Ear Plugs. When you are deaf. -1 accuracy.",
        "affinity": "blank, blank, blue, blank, blank",
        "bodyPart": "head",
        "armourPoints": 5,
        "craftLocation": "blacksmith",
        "expansion": "core",
    },
    {
        "name": "Lantern Gautlets",
        "keywords": "armor, set, metal, heavy",
        "numbers": null,
        "affinityDescription": "greenPuzzle +2 accuracy with club weapons.",
        "affinity": "blank, blank, blank, green, blank",
        "bodyPart": "arms",
        "armourPoints": 5,
        "craftLocation": "blacksmith",
        "expansion": "core",
    },
    {
        "name": "Lantern Cuirass",
        "keywords": "armor, set, metal, heavy",
        "numbers": null,
        "affinityDescription": "bluePuzzlegreenPuzzlebluePuzzlegreenPuzzleWhen you depart, add armorPoint3 to all hit locations with metal armor.",
        "affinity": "blue, green, blue, green, blank",
        "bodyPart": "body",
        "armourPoints": 5,
        "craftLocation": "blacksmith",
        "expansion": "core",
    },
    {
        "name": "Lantern Mail",
        "keywords": "armor, set, metal, heavy",
        "numbers": null,
        "description": null,
        "affinity": "blank, green, blank, blank, blank",
        "bodyPart": "waist",
        "armourPoints": 5,
        "craftLocation": "blacksmith",
        "expansion": "core",
    },
    {
        "name": "Lantern Greaves",
        "keywords": "armor, set, metal, heavy",
        "numbers": null,
        "affinityDescription": "redPuzzleredPuzzlebluePuzzle+2 movement",
        "affinity": "blue, red, blank, red, blank",
        "bodyPart": "legs",
        "armourPoints": 5,
        "craftLocation": "blacksmith",
        "expansion": "core",
    },
    {
        "name": "Lantern Sword",
        "keywords": "weapon, melee, sword, finesse, metal",
        "numbers": [3, 5, 3],
        "description": "Sharp: Add 1d10 Strength to each wound attempt.\nEarly Iron: When an attack roll result is 1, cancel any hits and end the attack.",
        "affinity": "blank, blank, blank, red, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "blacksmith",
        "expansion": "core",
    },
    {
        "name": "Perfect Slayer",
        "keywords": "weapon, melee, grand weapon, two-handed, sword, heavy, finesse, metal",
        "numbers": [3, 6, 14],
        "description": "Slow, Sharp, Devestating 2, Irreplaceable\n-2 movement.",
        "affinity": "blank, blank, red, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "blacksmith",
        "expansion": "core",
    },
    {
        "name": "Polishing Lantern",
        "keywords": "item, metal, lantern",
        "numbers": null,
        "description": "Ignore Early Iron\nSpend Activation to polish the edge of your or an adjacent survivor's finesse weapon. It gains +4 strength for its next attack. Limit once per attack.",
        "affinity": "blank, blank, blank, red, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "blacksmith",
        "expansion": "core",
    },
    {
        "name": "Ring Whip",
        "keywords": "weapon, melee, whip, finesse, metal",
        "numbers": [2, 5, 0],
        "description": "Sharp, Reach 2\nEarly Iron: When an attack roll result is 1, cancel any hits and end the attack.",
        "affinity": "blank, blank, blank, blue, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "blacksmith",
        "expansion": "core",
    },
    {
        "name": "Scrap Shield",
        "keywords": "weapon, melee, shield, bone, metal",
        "numbers": [2, 7, 3],
        "description": "Add 1 Armor Point to all hit locations.\nBlock 1: Spend Activation to ignore a hit the next time you are attacked. Lasts until your next act. "+
                       "You cannot use block more than once per attack.",
        "affinity": "blank, red, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "blacksmith",
        "expansion": "core",
    },
    {
        "name": "Survivor's Lantern",
        "keywords": "item, lantern",
        "numbers": null,
        "description": null,
        "affinity": "blank, green, blue, red, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "exhaustedLanternHoard",
        "expansion": "core",
    },
    {
        "name": "Death Mask",
        "keywords": "item, mask, bone, other",
        "numbers": null,
        "description": "Unique, Irreplaceable, Accessory\nIf you have no affinities, gain +4 luck and suffer -4 to all severe injury rolls.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": "head",
        "armourPoints": 2,
        "craftLocation": "maskMaker",
        "expansion": "core",
    },
    {
        "name": "God Mask",
        "keywords": "item, mask, bone, other",
        "numbers": null,
        "description": "Unique, Irreplaceable, Accessory",
        "affinityDescription": "redBoxredBoxblueBoxblueBoxgreenBoxgreenBoxAt the start of your act, if insane, gain +1 survival.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": "head",
        "armourPoints": 2,
        "craftLocation": "maskMaker",
        "expansion": "core",
    },
    {
        "name": "Man Mask",
        "keywords": "item, mask, bone, other",
        "numbers": null,
        "description": "Unique, Irreplaceable, Accessory",
        "affinityDescription": "redBoxgreenBoxIf insane, you may spend negative attribute tokens in place of survival.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": "head",
        "armourPoints": 2,
        "craftLocation": "maskMaker",
        "expansion": "core",
    },
    {
        "name": "Antelope Mask",
        "keywords": "item, mask, bone, other",
        "numbers": null,
        "description": "Unique, Irreplaceable, Accessory",
        "affinityDescription": "redBoxredBoxblueBoxblueBoxAt the start of your act, if insane, gain +1 movement.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": "head",
        "armourPoints": 2,
        "craftLocation": "maskMaker",
        "expansion": "core",
    },
    {
        "name": "Phoenix Mask",
        "keywords": "item, mask, bone, other",
        "numbers": null,
        "description": "Unique, Irreplaceable, Accessory",
        "affinityDescription": "redBoxredBoxredBoxredBoxIf insane, you may dodge 1 additional time per round.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": "head",
        "armourPoints": 2,
        "craftLocation": "maskMaker",
        "expansion": "core",
    },
    {
        "name": "White Lion Mask",
        "keywords": "item, mask, bone, other",
        "numbers": null,
        "description": "Unique, Irreplaceable, Accessory",
        "affinityDescription": "greenBoxgreenBoxIf insane, spend Activation to lose all your survival and gain that many +1 strength tokens.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": "head",
        "armourPoints": 2,
        "craftLocation": "maskMaker",
        "expansion": "core",
    },
    {
        "name": "Arc Bow",
        "keywords": "weapon, ranged, bow, two-handed",
        "numbers": [1, 6, 9],
        "description": "Slow, Range 6\nCumbersom: Spend Movement as an additional cost of activating this weapon.",
        "affinityDescription": "redPuzzlegreenPuzzleblueBoxRange +2",
        "affinity": "blank, green, blank, red, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "plumery",
        "expansion": "core, phoenix",
    },
    {
        "name": "Bird Bread",
        "keywords": "item, consumable, soluble",
        "numbers": null,
        "description": "Activation Consume: Once per showdown, add 1 to all hit locations. Gain priority target token. Roll 1d10. On a 1, reduce your survival to 0.",
        "affinity": "blank, green, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "plumery",
        "expansion": "core, phoenix",
    },
    {
        "name": "Blood Sheath",
        "keywords": "item, bone, other",
        "numbers": null,
        "description": "Block 1\nWhen Rainbow Katana is left of Blood Sheath, it loses Frail and gains Sharp (add 1d10 strength to each wound attempt).",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "plumery",
        "expansion": "core, phoenix",
    },
    {
        "name": "Bloom Sphere",
        "keywords": "item, stinky, other",
        "numbers": null,
        "affinityDescription": "greenPuzzlebluePuzzleWhen you are picked as a target, roll 1d10. On a 6+, the monster must pick a new target if possible.",
        "affinity": "blank, blue, blank, green, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "plumery",
        "expansion": "core, phoenix",
    },
    {
        "name": "Crest Crown",
        "keywords": "item, other",
        "numbers": null,
        "description": "Activation: If insane, reshuffle the hit location deck.",
        "affinityDescription": "bluePuzzlebluePuzzleredPuzzleWhen you depart, gain +1 insanity and +1 survival for every blueBox you have.",
        "affinity": "blue, red, blue, green, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "plumery",
        "expansion": "core, phoenix",
    },
    {
        "name": "Feather Mantle",
        "keywords": "item, flammable",
        "numbers": null,
        "description": "When you suffer knockback, you may ignore collision with other survivors and reduce the movement by up to 3 spaces.",
        "affinity": "blank, green, red, blue, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "plumery",
        "expansion": "core, phoenix",
    },
    {
        "name": "Feather Shield",
        "keywords": "weapon, melee, shield, flammable",
        "numbers": [3, 7, 0],
        "description": "Block 1",
        "affinityDescription": "greenBoxblueBoxredBoxReduce any suffered brain damage by 1 to a minimum of 1.",
        "affinity": "blue, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "plumery",
        "expansion": "core, phoenix",
    },
    {
        "name": "Finger of God",
        "keywords": "weapon, melee, spear, two-handed",
        "numbers": [2, 5, 5],
        "description": "Reach 2",
        "affinityDescription": "greenBoxblueBoxredBoxAs long as you have 5+ survival, gain +1 accuracy and +1 strength.",
        "affinity": "red, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "plumery",
        "expansion": "core, phoenix",
    },
    {
        "name": "Hollow Sword",
        "keywords": "weapon, melee, sword, dagger, bone",
        "numbers": [2, 5, 5],
        "description": "Frail\nThis weapon gains strength equal to the monster's damage attribute.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "plumery",
        "expansion": "core, phoenix",
    },
    {
        "name": "Hollowpoint Arrow",
        "keywords": "item, ammunition, arrow",
        "numbers": [1, 6, 11],
        "description": "Slow, Ammo - Bow\nOn a hit, monster gains -1 movement token. Use once per showdown.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "plumery",
        "expansion": "core, phoenix",
    },
    {
        "name": "Hours Ring",
        "keywords": "item, other",
        "numbers": null,
        "description": "Unqiue\nDuring the aftermath, if you died or ceased to exist, you may archive the Hours Ring and reset the campaign to the previous Settlement Phase's "+
                       "development step before you departed. Limit, once per campaign.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "plumery",
        "expansion": "core, phoenix",
    },
    {
        "name": "Rainbow Katana",
        "keywords": "weapon, melee, katana, finesse, two-handed",
        "numbers": [4, 4, 4],
        "description": "Frial",
        "affinityDescription": "redPuzzlegreenBoxblueBoxGains Deadly",
        "affinity": "blank, blank, blank, red, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "plumery",
        "expansion": "core, phoenix",
    },
    {
        "name": "Sonic Tomahawk",
        "keywords": "weapon, melee, axe, metal",
        "numbers": [3, 5, 6],
        "description": "On a Perfect hit, make 1 additional attack roll.",
        "affinityDescription": "redPuzzleredBoxblueBoxGain Savage and Paired.",
        "affinity": "blank, blank, blank, red, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "plumery",
        "expansion": "core, phoenix",
    },
    {
        "name": "Phoenix Helm",
        "keywords": "armor, set, feather, metal, flammable",
        "numbers": null,
        "affinityDescription": "bluePuzzlegreenBoxredBoxIf insane at the start of the showdown, gain +1 evasion token.",
        "affinity": "blank, blank, blue, blank, blank",
        "bodyPart": "head",
        "armourPoints": 4,
        "craftLocation": "plumery",
        "expansion": "core, phoenix",
    },
    {
        "name": "Phoenix Gauntlet",
        "keywords": "armor, set, feather, metal, flammable",
        "numbers": null,
        "description": "When you depart, gain +1 insanity.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": "arms",
        "armourPoints": 4,
        "craftLocation": "plumery",
        "expansion": "core, phoenix",
    },
    {
        "name": "Phoenix Plackart",
        "keywords": "armor, set, feather, metal, flammable",
        "numbers": null,
        "affinityDescription": "greenPuzzlebluePuzzleredPuzzleIf insane, ignore the first hit each round and suffer 1 brain damage instead.",
        "affinity": "blue, red, blank, green, blank",
        "bodyPart": "body",
        "armourPoints": 4,
        "craftLocation": "plumery",
        "expansion": "core, phoenix",
    },
    {
        "name": "Phoenix Faulds",
        "keywords": "armor, set, feather, metal, flammable",
        "numbers": null,
        "description": "When you depart, gain +1 insanity.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": "waist",
        "armourPoints": 4,
        "craftLocation": "plumery",
        "expansion": "core, phoenix",
    },
    {
        "name": "Phoenix Greaves",
        "keywords": "armor, set, feather, metal, flammable",
        "numbers": null,
        "description": "If insane, gain +2 movement.",
        "affinity": "blank, red, blank, blank, blank",
        "bodyPart": "legs",
        "armourPoints": 4,
        "craftLocation": "plumery",
        "expansion": "core, phoenix",
    },
    {
        "name": "Beast Knuckle",
        "keywords": "weapon, melee, katar, bone",
        "numbers": [2, 6, 4],
        "description": "Paired\nWhen you wound with this weapon, monster gains -1 toughness until the end of the attack.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "stoneCircle",
        "expansion": "core, screamingAntelope",
    },
    {
        "name": "Blood Paint",
        "keywords": "item, soluble",
        "numbers": null,
        "description": "Activation: Activate weapon gear to the left and right of this card. There are two separate attacks. Cannot be used with two-handed weapons.",
        "affinity": "blank, arrowRight, blank, arrowLeft, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "stoneCircle",
        "expansion": "core, screamingAntelope",
    },
    {
        "name": "Brain Mint",
        "keywords": "item, consumable",
        "numbers": null,
        "description": "Activation Consume: Remove all your tokens and stand up. You may use this while knocked down. Use once per showdown.",
        "affinity": "green, blank, blank, blue, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "stoneCircle",
        "expansion": "core, screamingAntelope",
    },
    {
        "name": "Bone Earrings",
        "keywords": "item, jewelry, bone",
        "numbers": null,
        "description": "At the start of the showdown, gain +2 speed and +2 strength tokens if insane and all gear in your gear grid has the bone keyword.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "stoneCircle",
        "expansion": "core, screamingAntelope",
    },
    {
        "name": "Boss Mehndi",
        "keywords": "item, soluble",
        "numbers": null,
        "description": "Boss is brave. While adjacent to you, insane survivors gain +1 speed.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "stoneCircle",
        "expansion": "core, screamingAntelope",
    },
    {
        "name": "Elder Earrings",
        "keywords": "item, jewelry",
        "numbers": null,
        "description": "At the start of the showdown, gain +2 survival.\n+1 Hunt XP after a showdown.",
        "affinity": "blank, green, blue, red, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "stoneCircle",
        "expansion": "core, screamingAntelope",
    },
    {
        "name": "Lance of Longinus",
        "keywords": "weapon, melee, spear, two-handed, bone",
        "numbers": [2, 6, 9],
        "description": "Irreplaceable, Reach 2\nEach showdown, the first time you wound the monster gains a -1 toughness token.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "stoneCircle",
        "expansion": "core, screamingAntelope",
    },
    {
        "name": "Speed Powder",
        "keywords": "item, soluble",
        "numbers": null,
        "description": "Activation: Suffer 2 brain damage. Gain +1 speed token. Use once per showdown.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "stoneCircle",
        "expansion": "core, screamingAntelope",
    },
    {
        "name": "Screaming Horns",
        "keywords": "item, set, bone",
        "numbers": null,
        "description": "Activation: Scream. Non-deaf, insane survivors gain +1 movement until the end of the round. Other non-deaf survivors gain +1 insanity.",
        "affinity": "blank, blank, blue, blank, blank",
        "bodyPart": "head",
        "armourPoints": 2,
        "craftLocation": "stoneCircle",
        "expansion": "core, screamingAntelope",
    },
    {
        "name": "Screaming Bracers",
        "keywords": "item, set, fur",
        "numbers": null,
        "description": "When you activate terrain, you may add +2 to your roll result.",
        "affinity": "green, blank, blank, red, blank",
        "bodyPart": "arms",
        "armourPoints": 2,
        "craftLocation": "stoneCircle",
        "expansion": "core, screamingAntelope",
    },
    {
        "name": "Screaming Coat",
        "keywords": "item, set, fur",
        "numbers": null,
        "description": "Slam: Spend Movement to full move forward in a straight line. If you move 4+ spaces and stop adjacent to a monster, "+
                       "it suffers knockback 1 and -1 toughness until the end of the round.",
        "affinity": "blue, blue, green, green, blank",
        "bodyPart": "body",
        "armourPoints": 2,
        "craftLocation": "stoneCircle",
        "expansion": "core, screamingAntelope",
    },
    {
        "name": "Screaming Skirt",
        "keywords": "item, set, fur",
        "numbers": null,
        "description": "This protective fur protects your parts. Add +1 to severe waist injury roll results.",
        "affinity": "blank, green, blue, blank, blank",
        "bodyPart": "waist",
        "armourPoints": 2,
        "craftLocation": "stoneCircle",
        "expansion": "core, screamingAntelope",
    },
    {
        "name": "Screaming Leg Warmers",
        "keywords": "item, set, fur",
        "numbers": null,
        "description": "On Arrival, your feet hurt. Gain +3 insanity.",
        "affinity": "blue, red, blank, blank, blank",
        "bodyPart": "legs",
        "armourPoints": 2,
        "craftLocation": "stoneCircle",
        "expansion": "core, screamingAntelope",
    },
    {
        "name": "Counterweighted Axe",
        "keywords": "weapon, melee, axe, two-handed",
        "numbers": [2, 6, 4],
        "description": "Reach 2",
        "affinityDescription": "redPuzzleOn a Perfect hit, monster suffers 1 wound, do not draw a hit location. Limit once per attack.",
        "affinity": "red, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "weaponCrafter",
        "expansion": "core",
    },
    {
        "name": "Scrap Bone Spear",
        "keywords": "weapon, melee, spear, bone, metal",
        "numbers": [2, 6, 3],
        "affinityDescription": "redPuzzleBarbed 4: On a Perfect hit, gain +4 strength for the rest of the attack.",
        "affinity": "blank, red, blank, green, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "weaponCrafter",
        "expansion": "core",
    },
    {
        "name": "Scrap Dagger",
        "keywords": "weapon, melee, dagger, metal",
        "numbers": [3, 7, 2],
        "description": "Barbed 2: On a Perfect hit, gain +2 strength for the rest of the attack.",
        "affinity": "blank, red, red, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "weaponCrafter",
        "expansion": "core",
    },
    {
        "name": "Scrap Lantern",
        "keywords": "item, metal, lantern",
        "numbers": null,
        "description": "When you depart, gain +1 survival.",
        "affinityDescription": "redBoxblueBox+1 accuracy",
        "affinity": "blank, blue, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "weaponCrafter",
        "expansion": "core",
    },
    {
        "name": "Scrap Rebar",
        "keywords": "item, metal, heavy",
        "numbers": null,
        "description": "The weapon to the left loses frail and gains unwieldy. If you attempt to wound a Super-dense location with the weapon, archive this at the end of the attack.",
        "affinity": "blank, blank, blank, leftArrow, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "weaponCrafter",
        "expansion": "core",
    },
    {
        "name": "Scrap Sword",
        "keywords": "weapon, melee, sword, metal",
        "numbers": [2, 5, 3],
        "description": "Barbed 4: On a Perfect hit, gain +4 strength for the rest of the attack.",
        "affinityDescription": "redBoxredBoxblueBoxGains Deadly",
        "affinity": "blue, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "weaponCrafter",
        "expansion": "core",
    },
    {
        "name": "Skullcap Hammer",
        "keywords": "weapon, melee, club, bone",
        "numbers": [2, 7, 3],
        "description": "On a Perfect hit, the monster is dazed, and gains -1 speed token until the end of its turn. A monster can be dazed once per round.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "weaponCrafter",
        "expansion": "core",
    },
    {
        "name": "Whistling Mace",
        "keywords": "weapon, melee, club, bone",
        "numbers": [3, 6, 3],
        "description": "On a Perfect hit, reveal the next aiCard. Place it on top or bottom of the AI deck.\nUnwieldy: If any attack roll results are 1, you hit yourself and suffer 1 damage.",
        "affinity": "blank, blank, green, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "weaponCrafter",
        "expansion": "core",
    },
    {
        "name": "Zanbato",
        "keywords": "weapon, melee, grand weapon, two-handed, bone, mineral",
        "numbers": [1, 6, 6],
        "description": "Slow, Frail, Deadly",
        "affinityDescription": "redPuzzlegreenBoxGains Devastating 1: Whenever you wound, inflict 1 additional wound.",
        "affinity": "red, green, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "weaponCrafter",
        "expansion": "core",
    },
    {
        "name": "Adventure Sword",
        "keywords": "weapon, melee, finesse, sword, other",
        "numbers": [3, 6, 0],
        "description": "Unique, Irreplaceable\nYour courage is added to this weapon's strength.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "rare",
        "expansion": "core",
    },
    {
        "name": "Butcher Cleaver",
        "keywords": "weapon, melee, axe, other",
        "numbers": [2, 5, 5],
        "description": "Paired\nSentient: Must be insane to activate.\nIrreplaceable: When you die, archive this card.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "rare",
        "expansion": "core",
    },
    {
        "name": "Forsaker Mask",
        "keywords": "item, mask, metal, other",
        "numbers": null,
        "description": "Unique, Irreplaceable, Accessory\nDuring the Aftermath, you run off into the darkness never to be seen again.\nDuring the Settlement Phase, you may archive this item to build the Mask Maker location.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": "head",
        "armourPoints": 2,
        "craftLocation": "rare",
        "expansion": "core",
    },
    {
        "name": "Lantern Halberd",
        "keywords": "weapon, melee, two-handed, spear, other, lantern",
        "numbers": [2, 4, 7],
        "description": "Reach 2, Irreplaceable, Unique\nAfter attacking, if standing, you may move up to 2 spaces directly away from the monster.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "rare",
        "expansion": "core",
    },
    {
        "name": "Muramasa",
        "keywords": "weapon, melee, katana, two-handed, finesse, other",
        "numbers": [6, 6, 6],
        "description": "Frail, Sharp, Sentient, Deadly 2, Unique\nWhen you critically wound with this weapon, gain 2 bleeding tokens.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "rare",
        "expansion": "core",
    },
    {
        "name": "Regal Faulds",
        "keywords": "armor, bone, metal",
        "numbers": null,
        "description": "Cursed\nAt the Aftermath, storyEvent King's Curse.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": "waist",
        "armourPoints": 4,
        "craftLocation": "rare",
        "expansion": "core",
    },
    {
        "name": "Regal Gauntlet",
        "keywords": "armor, bone, metal",
        "numbers": null,
        "description": "Cursed\nAt the Aftermath, storyEvent King's Curse.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": "arms",
        "armourPoints": 4,
        "craftLocation": "rare",
        "expansion": "core",
    },
    {
        "name": "Regal Greaves",
        "keywords": "armor, bone, metal",
        "numbers": null,
        "description": "Cursed\nAt the Aftermath, storyEvent King's Curse.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": "legs",
        "armourPoints": 4,
        "craftLocation": "rare",
        "expansion": "core",
    },
    {
        "name": "Regal Helm",
        "keywords": "armor, bone, metal",
        "numbers": null,
        "description": "Cursed\nAt the Aftermath, storyEvent King's Curse.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": "head",
        "armourPoints": 4,
        "craftLocation": "rare",
        "expansion": "core",
    },
    {
        "name": "Regal Plackart",
        "keywords": "armor, bone, metal",
        "numbers": null,
        "description": "Cursed\nAt the Aftermath, storyEvent King's Curse.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": "body",
        "armourPoints": 4,
        "craftLocation": "rare",
        "expansion": "core",
    },
    {
        "name": "Steel Shield",
        "keywords": "weapon, melee, shield, metal, heavy",
        "numbers": [1, 6, 6],
        "description": "Irreplaceable\n-3 movement. Spend Activation or 1 survival to ignore a hit.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "rare",
        "expansion": "core",
    },
    {
        "name": "Steel Sword",
        "keywords": "weapon, melee, sword, finesse, metal",
        "numbers": [1, 4, 5],
        "description": "Irreplaceable, Slow, Sharp\nBarbed 1d10: On a Perfect hit, gain +1d10 strength for the rest of the attack.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "rare",
        "expansion": "core",
    },
    {
        "name": "Thunder Maul",
        "keywords": "weapon, melee, club, two-handed, other",
        "numbers": [2, 6, 10],
        "description": "Irreplaceable, Unique, Cursed\nOn a Perfect hit, the monster is knocked down. Suffer a severe arm injury. All non-deaf survivors suffer 1 brain damage.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "rare",
        "expansion": "core",
    },
    {
        "name": "Twilight Sword",
        "keywords": "weapon, melee, two-handed, finesse, other",
        "numbers": [1, 0, 9],
        "description": "Slow, Cursed, Cumbersome, Sentient, Irreplaceable\nGains Devastating 2 when fighting the Watcher.\n*Accuracy = 9 - Twilight Sword Proficiency level.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "rare",
        "expansion": "core",
    },
    {
        "name": "Dragonskull Helm",
        "keywords": "armor, set, bone, metal",
        "numbers": null,
        "affinityDescription": "redPuzzleredPuzzleGain +1 to all severe head injury roll results. Ignore the shattered jaw severe Head injury result.",
        "affinity": "blank, red, red, red, blank",
        "bodyPart": "head",
        "armourPoints": 4,
        "craftLocation": "dragonArmory",
        "expansion": "dragonKing",
    },
    {
        "name": "Dragon Gloves",
        "keywords": "armor, set, metal",
        "numbers": null,
        "description": null,
        "affinity": "blue, green, blank, blank, blank",
        "bodyPart": "arms",
        "armourPoints": 4,
        "craftLocation": "dragonArmory",
        "expansion": "dragonKing",
    },
    {
        "name": "Dragon Mantle",
        "keywords": "armor, set, metal",
        "numbers": null,
        "affinityDescription": "greenPuzzleredPuzzlegreenPuzzlebluePuzzleAt the start of the showdown, you beat your chest mightily and gain survival up to the survival limit.",
        "affinity": "red, blue, green, green, blank",
        "bodyPart": "body",
        "armourPoints": 4,
        "craftLocation": "dragonArmory",
        "expansion": "dragonKing",
    },
    {
        "name": "Dragon Belt",
        "keywords": "armor, set, metal",
        "numbers": null,
        "affinityDescription": "bluePuzzleredPuzzleYou are not knocked down from suffering a heavy injury.",
        "affinity": "blank, blank, blue, red, blank",
        "bodyPart": "waist",
        "armourPoints": 4,
        "craftLocation": "dragonArmory",
        "expansion": "dragonKing",
    },
    {
        "name": "Dragon Boots",
        "keywords": "armor, set, metal",
        "numbers": null,
        "description": "Gain +2 movement during your act.",
        "affinity": "green, red, blank, blank, blank",
        "bodyPart": "legs",
        "armourPoints": 4,
        "craftLocation": "dragonArmory",
        "expansion": "dragonKing",
    },
    {
        "name": "Blast Shield",
        "keywords": "weapon, melee, shield, metal",
        "numbers": [1, 7, 4],
        "description": "Add armorPoint1 to all hit locations\nBlock 1. The first time you block a hit each showdown, gain the priority target token.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "dragonArmory",
        "expansion": "dragonKing",
    },
    {
        "name": "Blast Sword",
        "keywords": "weapon, melee, sword, bone",
        "numbers": [2, 6, 4],
        "description": "Block 1\nWhen you spend Activation to block with this weapon, gain +1 survival.",
        "affinity": "green, blank, red, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "dragonArmory",
        "expansion": "dragonKing",
    },
    {
        "name": "Blue Power Core",
        "keywords": "item, jewelry",
        "numbers": null,
        "description": "All nuclear gear cards in your gear grid gain Deadly 2.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "dragonArmory",
        "expansion": "dragonKing",
    },
    {
        "name": "Dragon Bite Bolt",
        "keywords": "item, ammunition, arrow",
        "numbers": [1, 6, 6],
        "description": "Slow, Ammo - Bow, Devastating 1\nIf you wound the monster, it suffers knockback 5. Use one per showdown.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "dragonArmory",
        "expansion": "dragonKing",
    },
    {
        "name": "Dragon Chakram",
        "keywords": "weapon, ranged, thrown, bone",
        "numbers": [2, 6, 3],
        "description": "Range 3\nIf you hit, the monster gains -1 evasion until the end of the round. Limit, once per attack.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "dragonArmory",
        "expansion": "dragonKing",
    },
    {
        "name": "Nuclear Knife",
        "keywords": "weapon, melee, dagger, nuclear",
        "numbers": [3, 6, 3],
        "affinityDescription": "greenPuzzleredPuzzlebluePuzzleActivation Edge ignites! Suffer 3 brain damage. Your next attack with this weapon gains Devastating 1. Limit, once per round.",
        "affinity": "blue, red, green, blue, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "dragonArmory",
        "expansion": "dragonKing",
    },
    {
        "name": "Nuclear Scythe",
        "keywords": "weapon, melee, scythe, two-handed, nuclear",
        "numbers": [2, 6, 4],
        "affinityDescription": "redPuzzleredPuzzlebluePuzzleActivation Edge ignites! Suffer 3 brain damage. Your next attack with this weapon gains Devastating 1. Limit, once per round.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "dragonArmory",
        "expansion": "dragonKing",
    },
    {
        "name": "Red Power Core",
        "keywords": "item, jewelry",
        "numbers": null,
        "description": "All nuclear gear cards in your gear grid gain Sharp.",
        "affinity": "red, blank, red, blue, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "dragonArmory",
        "expansion": "dragonKing",
    },
    {
        "name": "Shielded Quiver",
        "keywords": "item, leather",
        "numbers": null,
        "description": "You may activate and gain the benefits of each arrow gear in your grid one additional time each showdown.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "dragonArmory",
        "expansion": "dragonKing",
    },
    {
        "name": "Talon Knife",
        "keywords": "weapon, melee, katar, bone",
        "numbers": [2, 6, 4],
        "description": "Paired\nIf all of your attack rolls hit, gain Savage and Deadly until the end of your attack.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "dragonArmory",
        "expansion": "dragonKing",
    },
    {
        "name": "Celestial Spear",
        "keywords": "weapon, melee, spear, metal",
        "numbers": [2, 5, 4],
        "description": "Reach 2\nGain +5 strength when attacking with this weapon if you have a constellation.",
        "affinity": "blue, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "rare",
        "expansion": "dragonKing",
    },
    {
        "name": "Husk of Destiny",
        "keywords": "item, other",
        "numbers": null,
        "description": "Cursed\nYour destiny is fulfilled. You are always insane.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "rare",
        "expansion": "dragonKing",
    },
    {
        "name": "Dragon Vestments",
        "keywords": "item, silk, other",
        "numbers": null,
        "description": "Add armorPoint1 to all hit locations.\nWhen you gain a random fighting art, select a Dragon Trait one instead.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "rare",
        "expansion": "dragonKing",
    },
    {
        "name": "Hazmat Shield",
        "keywords": "weapon, melee, shield, metal, heavy",
        "numbers": [2, 4, 7],
        "description": "Block 2\nAdd armorPoint2 to all hit locations.\nWhen the monster performs Unseen Agony or Meltdown, roll 1d10. On a 2+ you suffer no damage.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "rare",
        "expansion": "dragonKing",
    },
    {
        "name": "Regal Edge",
        "keywords": "weapon, melee, sword, metal",
        "numbers": [1, 5, 2],
        "description": "Sharp\nGain +1 speed and +4 strength when attacking with this weapon if you have a Constellation.",
        "affinity": "green, blank, blank, red, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "rare",
        "expansion": "dragonKing",
    },
    {
        "name": "Gorment Mask",
        "keywords": "armor, set, gormskin, heavy",
        "numbers": null,
        "affinityDescription": "bluePuzzlegreenPuzzleIf your courage is higher than Monster Level, ignore intimidate actions.",
        "affinity": "blue, blank, green, blank, blank",
        "bodyPart": "head",
        "armourPoints": 2,
        "craftLocation": "gormery",
        "expansion": "gorm",
    },
    {
        "name": "Gorment Sleeves",
        "keywords": "armor, set, gormskin, heavy",
        "numbers": null,
        "affinityDescription": "greenBoxgreenBoxYou may Guard without spending survival.",
        "affinity": "blank, green, blank, blank, blank",
        "bodyPart": "arms",
        "armourPoints": 2,
        "craftLocation": "gormery",
        "expansion": "gorm",
    },
    {
        "name": "Gorment Suit",
        "keywords": "armor, set, gormskin, heavy",
        "numbers": null,
        "affinityDescription": "blueBoxgreenPuzzleredBoxGuard: At the end of your attack, if you are standing and have a shield in your gear grid, "+
                               "spend 1 survival to move 3 spaces directly away from the monster and Block 1 for free.",
        "affinity": "blank, blank, blank, green, blank",
        "bodyPart": ["body", "waist"],
        "armourPoints": 2,
        "craftLocation": "gormery",
        "expansion": "gorm",
    },
    {
        "name": "Gorment Boots",
        "keywords": "armor, set, gormskin, heavy",
        "numbers": null,
        "description": "Other survivors may move through but not end movement in a space you occupy.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": "legs",
        "armourPoints": 2,
        "craftLocation": "gormery",
        "expansion": "gorm",
    },
    {
        "name": "Regeneration Suit",
        "keywords": "item, gorm",
        "numbers": null,
        "affinityDescription": "greenPuzzlegreenBoxgreenBoxAt the end of the showdown, remove any permanent injuries you suffered this showdown.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": "body",
        "armourPoints": 2,
        "craftLocation": "gormery",
        "expansion": "gorm",
    },
    {
        "name": "Acid-Tooth Dagger",
        "keywords": "weapon, melee, dagger, bone",
        "numbers": [2, 7, 2],
        "description": "Paired\nOn a Perfect hit, a wound attempt in your attack automatically succeeds.",
        "affinity": "red, blank, red, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "gormery",
        "expansion": "gorm",
    },
    {
        "name": "Armor Spikes",
        "keywords": "item, bone, heavy",
        "numbers": null,
        "description": "If adjacent to the monster when you suffer a severe body injury, the monster suffers a wound. Limit, once per round.",
        "affinity": "blank, blank, blue, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "gormery",
        "expansion": "gorm",
    },
    {
        "name": "Black Sword",
        "keywords": "weapon, melee, sword, heavy",
        "numbers": [3, 5, 10],
        "description": "On a Perfect hit, gain +1 survival. If you are a Sword Master, you understand this weapon's potential, it gains +20 strength.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "gormery",
        "expansion": "gorm",
    },
    {
        "name": "Gaxe",
        "keywords": "weapon, melee, axe, bone",
        "numbers": [1, 6, 4],
        "affinityDescription": "redBoxGains +1 speed and Savage.\nEach showdown. the first time you critically wound the monster, it gains -1 evasion token.",
        "affinity": "red, blank, blank, red, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "gormery",
        "expansion": "gorm",
    },
    {
        "name": "Gorn",
        "keywords": "item, instrument, gormskin",
        "numbers": null,
        "description": "Activation: All non-deaf knocked down survivors stand and gain +1 to all hit locations. Use once per showdown.",
        "affinity": "blank, blank, blue, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "gormery",
        "expansion": "gorm",
    },
    {
        "name": "Greater Gaxe",
        "keywords": "weapon, melee, axe, two-handed, heavy",
        "numbers": [2, 6, 4],
        "description": "Deadly, Reach 2",
        "affinityDescription": "greenBoxredBoxOn a Perfect hit, the edge sharpens. Gain +4 strength for the rest of the attack.",
        "affinity": "blank, blank, blank, red, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "gormery",
        "expansion": "gorm",
    },
    {
        "name": "Knuckle Shield",
        "keywords": "weapon, melee, shield, gormskin",
        "numbers": [3, 7, 1],
        "description": "Block 1\nOnce per round, if you wound with this weapon, Block 1 for free.",
        "affinity": "blank, blank, red, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "gormery",
        "expansion": "gorm",
    },
    {
        "name": "Pulse Lantern",
        "keywords": "item, lantern, gormskin, fragile",
        "numbers": null,
        "description": "Activation: Once per showdown, roll 1d10. On a result of 4+, the monster is knocked down and all survivors gain -1 accuracy token.",
        "affinity": "red, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "gormery",
        "expansion": "gorm",
    },
    {
        "name": "Rib Blade",
        "keywords": "weapon, melee, grand weapon, bone",
        "numbers": [1, 6, 5],
        "description": "Slow, Deadly",
        "affinity": "blank, blue, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "gormery",
        "expansion": "gorm",
    },
    {
        "name": "Riot Mace",
        "keywords": "weapon, melee, club",
        "numbers": [2, 5, 5],
        "description": "Deadly\nWhen you critically wound, the next time the monster would draw AI, it performs Basic Action instead.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "gormery",
        "expansion": "gorm",
    },
    {
        "name": "Healing Potion",
        "keywords": "item, consumable, fragile",
        "numbers": null,
        "description": "At the end of the showdown, if you suffered any permanent injuries, you may archive this card and remove one of your choices.",
        "affinity": "blank, blank, red, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "gormchymist",
        "expansion": "gorm",
    },
    {
        "name": "Wisdom Potion",
        "keywords": "item, consumable, other",
        "numbers": null,
        "affinityDescription": "blueBoxbluePuzzlePlay the showdown with the top card of the hit location deck revealed.",
        "affinity": "blank, blue, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "gormchymist",
        "expansion": "gorm",
    },
    {
        "name": "Steadfast Potion",
        "keywords": "item, consumable, heavy",
        "numbers": null,
        "description": "When you ignore a hit with Block X, gain +1 strength token. When you are knocked down, lose all your +1 strength tokens.",
        "affinity": "red, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "gormchymist",
        "expansion": "gorm",
    },
    {
        "name": "Power Potion",
        "keywords": "item, consumable",
        "numbers": null,
        "description": "Activation: Consume: Once per showdown, gain +1 strength token for each Green Affinity Box you have.",
        "affinity": "green, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "gormchymist",
        "expansion": "gorm",
    },
    {
        "name": "Life Elixir",
        "keywords": "item, consumable, stinky",
        "numbers": null,
        "description": "Each showdown, the first time you would die from a severe injury, ignore that injury.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "gormchymist",
        "expansion": "gorm",
    },
    {
        "name": "Silk Turban",
        "keywords": "armor, set, silk, flammable",
        "numbers": null,
        "affinityDescription": "greenPuzzlebluePuzzleActivation Turn the monster to face away from you. Use only during the survivor's turn.",
        "affinity": "blank, green, blank, blue, blank",
        "bodyPart": "head",
        "armourPoints": 3,
        "craftLocation": "silkMill",
        "expansion": "spidicules",
    },
    {
        "name": "Silk Wraps",
        "keywords": "armor, set, silk, flammable",
        "numbers": null,
        "description": null,
        "affinity": "blank, blank, red, green, blank",
        "bodyPart": "arms",
        "armourPoints": 3,
        "craftLocation": "silkMill",
        "expansion": "spidicules",
    },
    {
        "name": "Silk Robes",
        "keywords": "armor, set, silk, flammable",
        "numbers": null,
        "description": "When you depart, gain +1 survival.",
        "affinityDescription": "redPuzzleredPuzzlebluePuzzleActivation Add 1 to all hit locations. Use once per showdown.",
        "affinity": "red, blue, red, blank, blank",
        "bodyPart": "body",
        "armourPoints": 3,
        "craftLocation": "silkMill",
        "expansion": "spidicules",
    },
    {
        "name": "Silk Sash",
        "keywords": "armor, set, silk, flammable",
        "numbers": null,
        "description": "When you depart, gain +1 survival.",
        "affinityDescription": "greenPuzzlegreenPuzzleActivation Add 1 to all hit locations. Use once per showdown.",
        "affinity": "blank, blank, green, green, blank",
        "bodyPart": "waist",
        "armourPoints": 3,
        "craftLocation": "silkMill",
        "expansion": "spidicules",
    },
    {
        "name": "Silk Boots",
        "keywords": "armor, set, silk, flammable",
        "numbers": null,
        "affinityDescription": "greenPuzzlegreenPuzzle+1 movement. Once per round, you may spend 1 survival to gain 2 insanity.",
        "affinity": "green, green, blank, blank, blank",
        "bodyPart": "legs",
        "armourPoints": 3,
        "craftLocation": "silkMill",
        "expansion": "spidicules",
    },
    {
        "name": "Amber Edge",
        "keywords": "weapon, melee, scimitar, amber",
        "numbers": [1, 6, 4],
        "description": "Slow\nAt the end of each attack, if you wounded the monster, make an additional attack with this weapon.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "silkMill",
        "expansion": "spidicules",
    },
    {
        "name": "Amber Poleaxe",
        "keywords": "weapon, melee, axe, spear, two-handed, amber",
        "numbers": [2, 6, 3],
        "description": "Reach 2\nWhen a monster collides with you, roll 1d10. On a 6+, the monster suffers 1 wound.",
        "affinity": "blank, blank, green, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "silkMill",
        "expansion": "spidicules",
    },
    {
        "name": "Blue Ring",
        "keywords": "item, jewelry, amber",
        "numbers": null,
        "description": "Unique, Accessory",
        "affinityDescription": "bluePuzzlebluePuzzlebluePuzzle If you are monster controller when the monster draws aiCard Icon, draw 1 extra card. Select 1 to play and discard the other.",
        "affinity": "blank, blue, blue, blue, blank",
        "bodyPart": "arms",
        "armourPoints": 2,
        "craftLocation": "silkMill",
        "expansion": "spidicules",
    },
    {
        "name": "Silk Body Suit",
        "keywords": "item, silk, flammable",
        "numbers": null,
        "description": "Reduce damage from every hit suffered by 2, to a minimum of 1. You may not have any heavy or metal armor in your gear grid.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "silkMill",
        "expansion": "spidicules",
    },
    {
        "name": "Green Ring",
        "keywords": "item, jewelry, amber",
        "numbers": null,
        "description": "Unique, Accessory",
        "affinityDescription": "greenPuzzlegreenPuzzlegreenPuzzle The first time you are attacked each round, gain armorPoint3 to all hit locations if you are monster controller.",
        "affinity": "green, green, green, blank, blank",
        "bodyPart": "arms",
        "armourPoints": 2,
        "craftLocation": "silkMill",
        "expansion": "spidicules",
    },
    {
        "name": "Hooded Scrap Katar",
        "keywords": "weapon, melee, katar, metal",
        "numbers": [2, 7, 4],
        "description": "Paired\nIf you hit 4 or more times in a single attack with this weapon, the monster suffer 1 wound before hit location are drawn.",
        "affinity": "blank, blank, blank, blue, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "silkMill",
        "expansion": "spidicules",
    },
    {
        "name": "Red Ring",
        "keywords": "item, jewelry, amber",
        "numbers": null,
        "description": "Unique, Accessory",
        "affinityDescription": "redPuzzleredPuzzleredPuzzle If you gain a bleeding token while monster controller, monster suffers 1 wound. Limit twice per round.",
        "affinity": "red, blank, red, red, blank",
        "bodyPart": "arms",
        "armourPoints": 2,
        "craftLocation": "silkMill",
        "expansion": "spidicules",
    },
    {
        "name": "Silk Bomb",
        "keywords": "item, thrown, silk, amber, fragile",
        "numbers": null,
        "description": "Activation: Until the end of the round, all survivors ignore knockback and bash. Archive after use.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "silkMill",
        "expansion": "spidicules",
    },
    {
        "name": "Silk Whip",
        "keywords": "weapon, melee, whip, silk",
        "numbers": [2, 6, 3],
        "affinityDescription": "bluePuzzlegreenPuzzle On a Perfect hit, you may archive a mood in play instead of drawing a hit location.",
        "affinity": "blank, blue, green, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "silkMill",
        "expansion": "spidicules",
    },
    {
        "name": "Throwing Knife",
        "keywords": "weapon, ranged, thrown",
        "numbers": [4, 9, 2],
        "description": "Range 4\nAt the end of your attack, gain +1 accuracy token for each Perfect hit. When knocked down, remove all you +1 accuracy tokens.",
        "affinity": "blank, red, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "silkMill",
        "expansion": "spidicules",
    },
    {
        "name": "Grinning Visage",
        "keywords": "weapon, melee, shield",
        "numbers": [2, 7, 4],
        "description": "Unique, Block 1\nWhen you wound with this shield, you may spend 1 survival to add armorPoint1 to all hit locations. Limit, once per attack.",
        "affinity": "green, blank, red, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "rare",
        "expansion": "spidicules",
    },
    {
        "name": "The Weaver",
        "keywords": "weapon, melee, sword, amber",
        "numbers": [3, 6, 2],
        "description": "Unique\nWhen you wound a monster, add armorPoint1 to a random hit location.",
        "affinity": "red, blank, blank, red, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "rare",
        "expansion": "spidicules",
    },
    {
        "name": "Sunring Bow",
        "keywords": "weapon, ranged, two-handed, bone",
        "numbers": [2, 4, 4],
        "description": "Range 5, Unique, Cumbersome",
        "affinityDescription": "redPuzzleredPuzzle On a Perfect hit, do not draw a hit location. Monster suffers 1 wound.",
        "affinity": "blank, red, blank, red, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "sacredPool",
        "expansion": "sunStalker",
    },
    {
        "name": "Prism Mace",
        "keywords": "weapon, melee, club, two-handed, bone",
        "numbers": [3, 6, 10],
        "description": "Unique, Block 1\nWhen you wound with this you may block 1 for free and discard 1 mood in play if you have any +1 strength tokens.",
        "affinity": "green, blue, green, red, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "sacredPool",
        "expansion": "sunStalker",
    },
    {
        "name": "Sun Vestments",
        "keywords": "item, silk, flammable",
        "numbers": null,
        "description": "Ignore Cumbersom",
        "affinityDescription": "redBoxredBox When you have any +1 strength tokens, increase the range of your Perfect hits by 1.",
        "affinity": "blank, red, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "sacredPool",
        "expansion": "sunStalker",
    },
    {
        "name": "Apostle Crown",
        "keywords": "item, jewelry, other",
        "numbers": null,
        "description": "At the start of your act, if you have any +1 strength tokens, reveal the next 4 monster hit locations and put them back in any order.",
        "affinity": "blank, red, blue, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "sacredPool",
        "expansion": "sunStalker",
    },
    {
        "name": "Cycloid Scale Hood",
        "keywords": "armor, set, scale",
        "numbers": null,
        "description": "Whenever you spend Movement, the scales' colors shift. Gain +1 evasion until your next act.",
        "affinity": "blank, blank, blank, blue, blank",
        "bodyPart": "head",
        "armourPoints": 2,
        "craftLocation": "skyreefSanctuary",
        "expansion": "sunStalker",
    },
    {
        "name": "Cycloid Scale Sleeves",
        "keywords": "armor, set, scale",
        "numbers": null,
        "description": "When you Shadow Walk and attack a monster from its blind spot, your weapon gains +1 accuracy and sharp for that attack.",
        "affinity": "blank, blue, blank, blue, blank",
        "bodyPart": "arms",
        "armourPoints": 2,
        "craftLocation": "skyreefSanctuary",
        "expansion": "sunStalker",
    },
    {
        "name": "Cycloid Scale Jacket",
        "keywords": "armor, set, scale",
        "numbers": null,
        "description": "When you spend Movement, you Shadow Walk and may move through spaces survivors occupy without causing collision.",
        "affinityDescription": "bluePuzzleredBoxredBox +1 accuracy.",
        "affinity": "blue, red, blank, red, blank",
        "bodyPart": "body",
        "armourPoints": 2,
        "craftLocation": "skyreefSanctuary",
        "expansion": "sunStalker",
    },
    {
        "name": "Cycloid Scale Skirt",
        "keywords": "armor, set, scale",
        "numbers": null,
        "affinityDescription": "greenPuzzleblueBoxblueBoxblueBox When you depart, gain survival equal to the number of Blue Affinity Icon you have.",
        "affinity": "blue, blank, green, blank, blank",
        "bodyPart": "waist",
        "armourPoints": 2,
        "craftLocation": "skyreefSanctuary",
        "expansion": "sunStalker",
    },
    {
        "name": "Cycloid Scale Shoes",
        "keywords": "armor, set, scale",
        "numbers": null,
        "affinityDescription": "bluePuzzlegreenPuzzleMovement You are not a threat until you attack. If you have the priority target token, gain +2 survival and remove it.",
        "affinity": "green, blank, blank, blue, blank",
        "bodyPart": "legs",
        "armourPoints": 2,
        "craftLocation": "skyreefSanctuary",
        "expansion": "sunStalker",
    },
    {
        "name": "Denticle Axe",
        "keywords": "weapon, melee, axe, scale",
        "numbers": [2, 6, 5],
        "affinityDescription": "bluePuzzleblueBoxredBox When attacking from the blind spot, the attack gains +2 strength and the first successful wound attempt gains Devastating 1.",
        "affinity": "blank, red, blue, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "skyreefSanctuary",
        "expansion": "sunStalker",
    },
    {
        "name": "Ink Blood Bow",
        "keywords": "weapon, ranged, bow, two-handed, other",
        "numbers": [2, 7, 8],
        "description": "Range 7, Deadly, Cumbersom\nGains +1 strength for each bleeding token you have. Loses cumbersome when in darkness.",
        "affinity": "red, blue, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "skyreefSanctuary",
        "expansion": "sunStalker",
    },
    {
        "name": "Ink Sword",
        "keywords": "weapon, melee, sword, fragile",
        "numbers": [4, 4, 4],
        "description": "Reach 3, Deadly 3\nYou may only attack with this while in darkness.",
        "affinity": "blank, blank, blank, blue, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "skyreefSanctuary",
        "expansion": "sunStalker",
    },
    {
        "name": "Quiver & Sun String",
        "keywords": "item, leather, scale",
        "numbers": null,
        "description": "You may carry up to 3 arrow gear cards outside of your grid. (All arrows you carry must be different.)",
        "affinityDescription": "blueBoxblueBoxredBoxAll your bows gain +2 range.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "skyreefSanctuary",
        "expansion": "sunStalker",
    },
    {
        "name": "Shadow Saliva Shawl",
        "keywords": "item, balm, stinky, other",
        "numbers": null,
        "description": "+2 evasion.\nCannot wear heavy, soluble, shield gear, or any gear with armorPoint3 or higher printed on it.",
        "affinityDescription": "greenPuzzlegreenPuzzlegreenBoxgreenBox+1 evasion. All weapons gain slow.",
        "affinity": "green, blank, green, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "skyreefSanctuary",
        "expansion": "sunStalker",
    },
    {
        "name": "Skleaver",
        "keywords": "weapon, melee, grand weapon, heavy, two-handed, bone",
        "numbers": [1, 5, 10],
        "description": "On the first Perfect hit each attack, this gains devastating 1 until the end of the attack.",
        "affinityDescription": "redPuzzleredBoxredBoxLoses the heavy keyword.",
        "affinity": "red, blank, red, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "skyreefSanctuary",
        "expansion": "sunStalker",
    },
    {
        "name": "Sky Harpoon",
        "keywords": "weapon, melee, thrown, spear",
        "numbers": [2, 5, 5],
        "description": "Reach 3, Savage\nOnce per showdown, if monster is within reach, roll 1d10. On a 6+, you skewer it! It suffers 1 wound. Move it up to 3 spaces towards you.",
        "affinity": "blank, blank, blank, red, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "skyreefSanctuary",
        "expansion": "sunStalker",
    },
    {
        "name": "Sun Lure and Hook",
        "keywords": "item, tool",
        "numbers": null,
        "description": "When you depart, gain +1 survival. After the Hunt Phase setup, place the Sky Fishing hunt event on any hunt space.",
        "affinity": "blank, blank, blue, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "skyreefSanctuary",
        "expansion": "sunStalker",
    },
    {
        "name": "Sunshark Arrows",
        "keywords": "item, ammunition, arrow, soluble",
        "numbers": [1, 4, 6],
        "description": "Activation Limit 3. May activate this up to 3 times per showdown (use tokens to track).",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "skyreefSanctuary",
        "expansion": "sunStalker",
    },
    {
        "name": "Sunshark Bow",
        "keywords": "weapon, melee, ranged, bow, two-handed",
        "numbers": [3, 6, 0],
        "affinityDescription": "redPuzzleredBoxredBoxGains +4 strength and slow.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "skyreefSanctuary",
        "expansion": "sunStalker",
    },
    {
        "name": "Sunspot Dart",
        "keywords": "weapon, ranged, thrown",
        "numbers": [4, 7, 3],
        "description": "Range 5, Deadly, Activation Limit 3\nWhen you hit, there is an inspiring flash! Survivors adjacent to the monster gain +1 survival.",
        "affinity": "blank, red, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "skyreefSanctuary",
        "expansion": "sunStalker",
    },
    {
        "name": "Sunspot Lantern",
        "keywords": "item, lantern",
        "numbers": null,
        "description": "+1 accuracy\nYou cast a 1-space shadow directly away from the monster. If the shadow could be cast in 2 spaces, decide which space has it until you move.",
        "affinity": "blank, green, blank, green, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "skyreefSanctuary",
        "expansion": "sunStalker",
    },
    {
        "name": "Eyepatch",
        "keywords": "item, leather",
        "numbers": null,
        "description": "While you wear this, you are blind in one eye (-1 accuracy). If you are already blind, gain +2 strength for being a badass instead.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "item, leather",
        "expansion": "sunStalker",
    },
    {
        "name": "God's String",
        "keywords": "item, other",
        "numbers": null,
        "description": "When a bow is below God's String, it gains sharp and its range is increased by 1.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "rare",
        "expansion": "sunStalker",
    },
    {
        "name": "DBK Errant Badge",
        "keywords": "item, jewelry, knight",
        "numbers": null,
        "description": "Unique\nAdd armorPoint1 to all hit locations. At the start of the showdown, draw 1 tactics card.",
        "affinity": "blank, red, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "wetResinCrafter",
        "expansion": "dungBeetleKnight",
    },
    {
        "name": "Digging Claw",
        "keywords": "weapon, melee, katar, pick-axe, bone, mineral",
        "numbers": [1, 4, 5],
        "description": "Paired\nDuring the storyEvent Mineral Gathering, you may reroll one of you d10.",
        "affinity": "blank, green, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "wetResinCrafter",
        "expansion": "dungBeetleKnight",
    },
    {
        "name": "Seasoned Monster Meat",
        "keywords": "item, consumable",
        "numbers": null,
        "description": "When you depart, gain +3 survival.",
        "affinityDescription": "redPuzzleActivation Consume: Gain +3 survival and +1 strength token. Limit, once per showdown.",
        "affinity": "green, red, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "wetResinCrafter",
        "expansion": "dungBeetleKnight",
    },
    {
        "name": "The Beetle Bomb",
        "keywords": "item, thrown, fragile",
        "numbers": null,
        "description": "Unique\nActivation: If adjacent to the monster, roll 1d10. On a 6+, the monster gains -1 accuracy and -1 evasion tokens. Limit, once per showdown.",
        "affinity": "blue, blank, red, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "wetResinCrafter",
        "expansion": "dungBeetleKnight",
    },
    {
        "name": "Scarab Circlet",
        "keywords": "item, bone, jewelry, other",
        "numbers": null,
        "description": "Add armorPoint1 to all hit locations. During the showdown, when your survival is reduced to 0, gain +1 strength token.",
        "affinity": "blue, blank, blue, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "wetResinCrafter",
        "expansion": "dungBeetleKnight",
    },
    {
        "name": "Rubber Bone Harness",
        "keywords": "item, bone, leather",
        "numbers": null,
        "description": "Once per showdown, you may convert all of your negative attribute tokens to positive attribute tokens of the same type.",
        "affinity": "red, green, blue, green, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "wetResinCrafter",
        "expansion": "dungBeetleKnight",
    },
    {
        "name": "Rainbow Wing Belt",
        "keywords": "item, flammable",
        "numbers": null,
        "affinityDescription": "redBoxredBoxblueBoxgreenBox When any of your attack rolls are 1, you may reroll them. Limit, once per attack.",
        "affinity": "red, green, blue, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "wetResinCrafter",
        "expansion": "dungBeetleKnight",
    },
    {
        "name": "Century Greaves",
        "keywords": "item, bone, mineral, heavy",
        "numbers": null,
        "description": "-1 movement. Add armorPoint1 to all hit locations.",
        "affinityDescription": "greenPuzzleblueBoxAdd +1 to Ripple Pattern roll results.",
        "affinity": "blank, blank, blank, green, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "wetResinCrafter",
        "expansion": "dungBeetleKnight",
    },
    {
        "name": "Calcified Shoulder Pads",
        "keywords": "item, bone, heavy",
        "numbers": null,
        "description": "Add armorPoint3 to all hit locations.",
        "affinityDescription": "greenPuzzlegreenBox Ripple Pattern: When you are attacked, roll 1d10. On a 10+, ignore 1 hit.",
        "affinity": "blank, blank, blank, green, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "wetResinCrafter",
        "expansion": "dungBeetleKnight",
    },
    {
        "name": "Calcified Digging Claw",
        "keywords": "weapon, melee, katar, pickaxe",
        "numbers": [1, 4, 5],
        "description": "Paired, Sharp\nDuring the storyEvent Mineral Gathering, you may reroll one of you d10.",
        "affinity": "blank, blank, blank, green, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "rare",
        "expansion": "dungBeetleKnight",
    },
    {
        "name": "Calcified Greaves",
        "keywords": "item, bone, heavy",
        "numbers": null,
        "description": "-1 movement. Add armorPoint3 to all hit locations.",
        "affinityDescription": "greenPuzzleblueBox Add +2 to Ripple Pattern roll results.",
        "affinity": "blank, blank, blank, green, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "rare",
        "expansion": "dungBeetleKnight",
    },
    {
        "name": "Calcified Juggernaut Blade",
        "keywords": "weapon, melee, grand, bone, other",
        "numbers": [1, 5, 9],
        "description": "Slow, Block 1\nThis weapon gains +1 strength for each token you have.",
        "affinity": "blank, red, blank, red, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "rare",
        "expansion": "dungBeetleKnight",
    },
    {
        "name": "Century Shoulder Pads",
        "keywords": "item, bone, mineral, heavy",
        "numbers": null,
        "description": "Add armorPoint1 to all hit locations.",
        "affinityDescription": "greenPuzzlegreenBox Ripple Pattern: When you are attacked, roll 1d10. On a 10+, ignore 1 hit.",
        "affinity": "blank, blank, blank, green, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "rare",
        "expansion": "dungBeetleKnight",
    },
    {
        "name": "Calcified Zanbato",
        "keywords": "weapon, melee, grand, two-handed, bone, heavy",
        "numbers": [1, 5, 8],
        "description": "Slow, Deadly",
        "affinityDescription": "redPuzzlegreenBox Gains Devastating 1: Whenever you wound, inflict 1 additional wound.",
        "affinity": "red, green, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "rare",
        "expansion": "dungBeetleKnight",
    },
    {
        "name": "Hidden Crimson Jewel",
        "keywords": "item, jewelry, other",
        "numbers": null,
        "description": "Unique, Irreplaceable\nOnce per game phase, you may reroll one d10.",
        "affinity": "red, red, red, red, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "rare",
        "expansion": "dungBeetleKnight",
    },
    {
        "name": "Regenerating Blade",
        "keywords": "item, mineral, other",
        "numbers": null,
        "description": "During the Settlement Phase, you may archive this to remove the Dismembered Arm or Dismembered Leg permanent injury from one survivor.",
        "affinity": "blank, blue, blank, green, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "rare",
        "expansion": "dungBeetleKnight",
    },
    {
        "name": "Trash Crown",
        "keywords": "item, jewelry, fragile, other",
        "numbers": null,
        "description": "Activation: Reveal the next 4 hit location cards and discard 3 that are not traps. Place remaining cards on top of the deck in any order.",
        "affinity": "blank, blank, red, blue, blank",
        "bodyPart": "head",
        "armourPoints": 4,
        "craftLocation": "rare",
        "expansion": "dungBeetleKnight",
    },
    {
        "name": "Vespertine Arrow",
        "keywords": "item, ammunition, arrow",
        "numbers": [2, 6, 0],
        "description": "Ammo - Bow, Deadly 4\nArchive after use. If your attack misses, place a Flower Patch terrain tile adjacent to the monster.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "senseMemory",
        "expansion": "flowerKnight",
    },
    {
        "name": "Vespertine Bow",
        "keywords": "weapon, ranged, bow, two-handed, other",
        "numbers": [3, 6, 1],
        "description": "Range 5, Deadly\nBefore each attack, you may choose for Vespertine Bow to have slow, +4 accuracy, and Range 9 for that attack.",
        "affinity": "blank, green, blank, blue, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "senseMemory",
        "expansion": "flowerKnight",
    },
    {
        "name": "Vespertine Cello",
        "keywords": "item, instrument, noisy, other",
        "numbers": null,
        "description": "Unique\nAt the start of the showdown, all other survivors with an instrument in their gear grid gain +1 luck token.",
        "affinity": "blank, blank, blue, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "senseMemory",
        "expansion": "flowerKnight",
    },
    {
        "name": "Vespertine Foil",
        "keywords": "weapon, melee, sword, fragile",
        "numbers": [4, 5, 1],
        "description": "At the beginning of each settlement phase, archive this unless you spend 1 Flower resource.",
        "affinityDescription": "bluePuzzleredPuzzle Gains Deadly 2.",
        "affinity": "blank, blue, blank, red, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "senseMemory",
        "expansion": "flowerKnight",
    },
    {
        "name": "Satchel",
        "keywords": "item, heavy, stinky",
        "numbers": null,
        "description": "You may depart with one resource card. If that resource is Perishable, it is not destroyed.",
        "affinity": "green, blank, green, green, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "senseMemory",
        "expansion": "flowerKnight",
    },
    {
        "name": "Flower Knight Badge",
        "keywords": "item, jewelry, badge",
        "numbers": null,
        "description": "Unique\nAt the start of the showdown, draw 1 tactics card and gain +1 evasion token.",
        "affinity": "blue, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "rare",
        "expansion": "flowerKnight",
    },
    {
        "name": "Flower Knight Helm",
        "keywords": "armor, heavy",
        "numbers": null,
        "description": "+1 Accuracy.",
        "affinityDescription": "bluePuzzle greenBox greenBox greenBox While you are being attacked, the monster has -1 speed.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": "head",
        "armourPoints": 3,
        "craftLocation": "rare",
        "expansion": "flowerKnight",
    },
    {
        "name": "Replica Flower Sword",
        "keywords": "weapon, melee, grand, sword",
        "numbers": [2, 6, 6],
        "description": "Devastating 1\nYou cannot dodge.",
        "affinityDescription": "greenPuzzle greenBox greenBox redBox Gains sharp. +1 evasion.",
        "affinity": "red, red, blank, green, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "rare",
        "expansion": "flowerKnight",
    },
    {
        "name": "Sleeping Virus Flower",
        "keywords": "item, flammable",
        "numbers": null,
        "description": "+1 luck, Cursed\nWhen you die, a flower blooms from your corpse. Add storyEvent A Warm Virus to the timeline next year. You are the guest.",
        "affinity": "blue, blue, blue, blue, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "rare",
        "expansion": "flowerKnight",
    },
    {
        "name": "Ancient Lion Claws",
        "keywords": "item, fur, heavy",
        "numbers": null,
        "description": "Unique, Accessory, -1 evasion\n+2 strength while attacking with daggers or katars. You may move up to 2 additional spaces when you pounce.",
        "affinity": "red, red, blank, blank, blank",
        "bodyPart": "arms",
        "armourPoints": 2,
        "craftLocation": "rare",
        "expansion": "lionGod",
    },
    {
        "name": "Bone Witch Mehndi",
        "keywords": "item, soluble, symbol, other",
        "numbers": null,
        "affinityDescription": "greenPuzzle bluePuzzle redPuzzle At the start of your act, you may spend 3 insanity to gain 1 survival or 1 survival to gain 3 insanity.",
        "affinity": "blue, red, blank, green, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "rare",
        "expansion": "lionGod",
    },
    {
        "name": "Butcher's Blood",
        "keywords": "item, soluble, symbol, other",
        "numbers": null,
        "affinityDescription": "blueBox blueBox blueBox redPuzzle For every 10 insanity you have, gain +1 speed and +1 strength.",
        "affinity": "red, blank, blank, red, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "rare",
        "expansion": "lionGod",
    },
    {
        "name": "Death Mehndi",
        "keywords": "item, soluble, symbol, other",
        "numbers": null,
        "description": "Cursed\nOn a Perfect hit, gain 1d10 insanity. -4 to all brain trauma rolls.",
        "affinity": "blank, blank, blank, blank, RGB",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "rare",
        "expansion": "lionGod",
    },
    {
        "name": "Glyph of Solitude",
        "keywords": "item, soluble, symbol, other",
        "numbers": null,
        "affinityDescription": "redBox redBox greenPuzzle +2 accuracy. You are deaf. You cannot encourage.",
        "affinity": "blank, green, green, blank, red",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "rare",
        "expansion": "lionGod",
    },
    {
        "name": "Golden Plate",
        "keywords": "item, metal, heavy",
        "numbers": null,
        "description": "Unique, -1 evasion",
        "affinityDescription": "redBox redBox redBox redBox When you depart, gain +2 to all locations wearing fur armor.",
        "affinity": "red, red, red, red, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "rare",
        "expansion": "lionGod",
    },
    {
        "name": "Lantern Mehndi",
        "keywords": "item, soluble, symbol, other",
        "numbers": null,
        "affinityDescription": "redBox redBox bluePuzzle You may start the showdown in any unoccupied board space.",
        "affinity": "blank, blank, blue, blank, red",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "rare",
        "expansion": "lionGod",
    },
    {
        "name": "Lion God Statue",
        "keywords": "item, stone, heavy",
        "numbers": null ,
        "description": "Unique, -1 evasion",
        "affinityDescription": "redPuzzle Gain +1 strength for each redBox you have.",
        "affinity": "blue, blank, blank, red, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "rare",
        "expansion": "lionGod",
    },
    {
        "name": "Necromancer's Eye",
        "keywords": "item, set, jewelry, other",
        "numbers": null,
        "description": "Unique, Accessory.\nIgnore the effects of blind.",
        "affinityDescription": "bluePuzzle Activation Reveal the next 4 monster hit locations. Put them back in any order.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": "head",
        "armourPoints": 2,
        "craftLocation": "rare",
        "expansion": "lionGod",
    },
    {
        "name": "Hideous Disguise",
        "keywords": "item, mask, bone, other",
        "numbers": null,
        "description": "Accessory, Cursed\nGain +1 strength. At the start of the showdown, if you are fighting the Lion Knight, choose your Role card.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "rare",
        "expansion": "lionKnight",
    },
    {
        "name": "Lion Knight Badge",
        "keywords": "item, jewelry, knight",
        "numbers": null,
        "description": "Unique\nGain +1 accuracy. At the start of the showdown, draw 1 Tactics card.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "rare",
        "expansion": "lionKnight",
    },
    {
        "name": "Lion Knight's Left Claw",
        "keywords": "weapon, melee, katar",
        "numbers": null,
        "description": "Paired with Lion Knight's Right Claw.",
        "affinityDescription": "redPuzzle: Gains Deadly.",
        "affinityDescription2": "bluePuzzle: Gains +1 speed.",
        "affinity": "blank, blue, blank, red, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "rare",
        "expansion": "lionKnight",
    },
    {
        "name": "Lion Knight's Right Claw",
        "keywords": "weapon, melee, katar",
        "numbers": null,
        "description": "Paired with Lion Knight's Left Claw.",
        "affinityDescription": "redPuzzle: On a Perfect hit, +1 survival.",
        "affinityDescription2": "bluePuzzle: Gains +1 speed.",
        "affinity": "blank, red, blank, blue, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "rare",
        "expansion": "lionKnight",
    },
    {
        "name": "Deathpact",
        "keywords": "item, metal, fragile",
        "numbers": null,
        "description": "Unique\nAt the start of your act, gain +1 survival.\nOnce per campaign, you may fire the gun to automatically hit and inflict a critical wound.",
        "affinity": "blue, red, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "rare",
        "expansion": "manhunter",
    },
    {
        "name": "Hunter's Heart",
        "keywords": "item, consumable, metal, heavy",
        "numbers": null,
        "description": "Unique\nIf you die, the heart crawls back to the settlement. Roll 1d10. On a 7+, it regrows you.\nDuring the settlement phase, you may archive this to storyEvent Bleeding Heart.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "rare",
        "expansion": "manhunter",
    },
    {
        "name": "Manhunter's Hat",
        "keywords": "item, rawhide, leather",
        "numbers": null,
        "description": "Unique, Accessory, Outfit",
        "affinityDescription": "bluePuzzle redBox Ignore the first severe Head injury you suffer each showdown.",
        "affinity": "red, blank, blue, red, blank",
        "bodyPart": "head",
        "armourPoints": 2,
        "craftLocation": "rare",
        "expansion": "manhunter",
    },
    {
        "name": "Reverberating Lantern",
        "keywords": "item, tool, lantern",
        "numbers": null,
        "description": "Unique\nAt the start of any hunt turn, before an event is revealed, you may storyEvent Sonorous Rest. Limit, once per hunt.",
        "affinity": "green, blue, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "rare",
        "expansion": "manhunter",
    },
    {
        "name": "Tool Belt",
        "keywords": "item, metal, fragile",
        "numbers": null,
        "description": "Unique\nIf you have no weapons in your gear grid, gain +3 evasion.\nTools in your gear grid lose frail. Tools with attack profiles gain +1 speed, +3 accuracy, and sharp.",
        "affinity": "blue, green, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "rare",
        "expansion": "manhunter",
    },
    {
        "name": "Dark Water Vial",
        "keywords": "item, consumable, gloomy, fragile",
        "numbers": null,
        "description": "Activation Consume: You are knocked down and cannot gain bleeding tokens until the end of the round. Use once per showdown.",
        "affinity": "blank, blank, green, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "lightForging",
        "expansion": "slenderman",
    },
    {
        "name": "Gloom Bracelets",
        "keywords": "item, jewelry, gloomy, fragile, heavy",
        "numbers": null,
        "description": "Accessory\nWhen you depart, gain +2 insanity. When you suffer a severe arm injury, archive this card.",
        "affinity": "blank, red, blue, red, blank",
        "bodyPart": "arms",
        "armourPoints": 6,
        "craftLocation": "lightForging",
        "expansion": "slenderman",
    },
    {
        "name": "Gloom Cream",
        "keywords": "item, consumable, balm, gloomy, stinky, other",
        "numbers": null,
        "affinityDescription": "redPuzzle redPuzzle blueBox blueBox When you depart, gain -3 Hunt XP, -1 understanding. If you have no understanding, die instantly.",
        "affinity": "blue, red, blue, red, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "lightForging",
        "expansion": "slenderman",
    },
    {
        "name": "Gloom Hammer",
        "keywords": "weapon, melee, club, two-handed, gloomy, other",
        "numbers": [2, 7, 13],
        "description": "Unique, Sentient, Reach 2, Deadly\nWhen you wound, end your attack (cancel reactions). Gain the monster controller tile and full move the monster directly away from you.",
        "affinity": "blue, blank, blank, red, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "lightForging",
        "expansion": "slenderman",
    },
    {
        "name": "Gloom Katana",
        "keywords": "weapon, melee, katana, two-handed, gloomy, other, finesse",
        "numbers": [4, 5, 0],
        "description": "Your insanity is added to this weapon's strength. When Gloom Sheath is right of this in your gear grid, Gloom Katana gains Savage.",
        "affinity": "blue, rightArrow, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "lightForging",
        "expansion": "slenderman",
    },
    {
        "name": "Gloom Mehndi",
        "keywords": "item, gloomy, soluble",
        "numbers": null,
        "description": "When you depart, gain armorPoint1 to all hit locations. When you gain the Crystal Skin ability, gain the Crystal Sword Mold strange resource.",
        "affinity": "blank, red, blue, red, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "lightForging",
        "expansion": "slenderman",
    },
    {
        "name": "Gloom Sheath",
        "keywords": "item, gloomy, other",
        "numbers": null,
        "affinityDescription": "redPuzzle blueBox At the start of your act, gain +1 insanity.",
        "affinity": "red, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "lightForging",
        "expansion": "slenderman",
    },
    {
        "name": "Gloom-Coated Arrow",
        "keywords": "item, ammunition, arrow, gloomy",
        "numbers": [5, 6, 5],
        "description": "Ammo - Bow, Cumbersome, Deadly\nAfter attempting to wound each hit location, place it on top of the deck instead of in the discard pile. Use once per showdown.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "lightForging",
        "expansion": "slenderman",
    },
    {
        "name": "Raptor-Worm Collar",
        "keywords": "item, jewelry, gloomy",
        "numbers": null,
        "description": "You may encourage without spending survival. When you encourage a survivor, they suffer 2 brain damage.",
        "affinity": "blank, blank, green, red, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "lightForging",
        "expansion": "slenderman",
    },
    {
        "name": "Slender Ovule",
        "keywords": "item, jewelry, gloomy, other",
        "numbers": null,
        "description": "Unique\nWhen you depart, gain +3 insanity.",
        "affinityDescription": "bluePuzzle greenPuzzle Monsters and survivors adjacent to you have -1 luck.",
        "affinity": "blank, green, blue, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "lightForging",
        "expansion": "slenderman",
    },
    {
        "name": "Green Helm",
        "keywords": "armor, set, bone, metal",
        "numbers": null,
        "description": "+1 luck\nWhen a monster attacks you, you may elect to take a hit on the head and roll 1d10. On a 6+, ignore a hit, if adjacent, it suffers 1 wound.",
        "affinity": "blank, blank, green, red, blank",
        "bodyPart": "head",
        "armourPoints": 5,
        "craftLocation": "greenKnight",
        "expansion": "greenKnight",
    },
    {
        "name": "Green Gloves",
        "keywords": "armor, set, metal",
        "numbers": null,
        "description": "+2 strength",
        "affinityDescription": "redPuzzle redPuzzle +6 Luck attempting to wound Parry hit locations.",
        "affinity": "blank, red, red, blank, blank",
        "bodyPart": "arms",
        "armourPoints": 5,
        "craftLocation": "greenKnight",
        "expansion": "greenKnight",
    },
    {
        "name": "Green Plate",
        "keywords": "armor, set, metal, gormskin",
        "numbers": null,
        "description": "At the start of the showdown, draw 3 tactics cards.",
        "affinityDescription": "bluePuzzle bluePuzzle greenPuzzle greenPuzzle When you attack, the extra weight grants leverage. Your weapon gains the club keyword.",
        "affinity": "green, blue, blue, green, blank",
        "bodyPart": "body",
        "armourPoints": 5,
        "craftLocation": "greenKnight",
        "expansion": "greenKnight",
    },
    {
        "name": "Green Faulds",
        "keywords": "armor, set, metal, other",
        "numbers": null,
        "description": "+1 Evasion",
        "affinityDescription": "bluePuzzle greenPuzzle After drawing hit locations from an attack, you may discard 1 First Strike hit location card.",
        "affinity": "blue, green, blank, blank, blank",
        "bodyPart": "waist",
        "armourPoints": 5,
        "craftLocation": "greenKnight",
        "expansion": "greenKnight",
    },
    {
        "name": "Green Boots",
        "keywords": "armor, set, bone, heavy, metal",
        "numbers": null,
        "description": "You may use the Tumble fighting art.",
        "affinityDescription": "greenPuzzle greenPuzzle You successfully tumble on a 2+ instead of a 6+.",
        "affinity": "green, blank, blank, green, blank",
        "bodyPart": "legs",
        "armourPoints": 5,
        "craftLocation": "greenKnight",
        "expansion": "greenKnight",
    },
    {
        "name": "Griswaldo",
        "keywords": "weapon, set, melee, sword, finesse, bone, metal",
        "numbers": [3, 4, 15],
        "description": "Sharp, Deadly, Savage\nWhen you wound, Block 2 with Fetorsaurus for free.",
        "affinity": "red, green, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "greenKnight",
        "expansion": "greenKnight",
    },
    {
        "name": "Fetorsaurus",
        "keywords": "weapon, set, melee, shield, metal",
        "numbers": [2, 5, 9],
        "description": "Block 2\nAdd armorPoint2 to all hit locations. While you carry this, reduce Monster Level by 1.",
        "affinity": "blank, blank, green, blue, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "greenKnight",
        "expansion": "greenKnight",
    },
    {
        "name": "Singing Cap",
        "keywords": "armor, set, flesh",
        "numbers": null,
        "affinityDescription": "greenPuzzle bluePuzzle When you are attacked and suffer more than 1 hit, ignore 1 hit.",
        "affinity": "green, blank, blue, blank, blank",
        "bodyPart": "head",
        "armourPoints": 3,
        "craftLocation": "chorusseum",
        "expansion": "gamblersChest, smogSingers",
    },
    {
        "name": "Singing Gloves",
        "keywords": "armor, set, flesh",
        "numbers": null,
        "description": "Reduce the cost of performing your Ballads by 1.",
        "affinity": "blank, blue, blank, green, blank",
        "bodyPart": "arms",
        "armourPoints": 3,
        "craftLocation": "chorusseum",
        "expansion": "gamblersChest, smogSingers",
    },
    {
        "name": "Singing Breastplate",
        "keywords": "armor, set, flesh",
        "numbers": null,
        "description": "Hit Song: Spend Movement Activation to full move forward and attack. If you moved at least 4 spaces, the first time you wound during this attack, encourage all survivors.",
        "affinity": "blue, red, blank, blank, blank",
        "bodyPart": "body",
        "armourPoints": 3,
        "craftLocation": "chorusseum",
        "expansion": "gamblersChest, smogSingers",
    },
    {
        "name": "Singing Pantaloons",
        "keywords": "armor, set, flesh",
        "numbers": null,
        "description": null,
        "affinity": "blank, blank, green, blank, blank",
        "bodyPart": "waist",
        "armourPoints": 3,
        "craftLocation": "chorusseum",
        "expansion": "gamblersChest, smogSingers",
    },
    {
        "name": "Singing Boots",
        "keywords": "armor, set, flesh",
        "numbers": null,
        "affinityDescription": "greenPuzzle blueBox At the end of your act, you may move up to 3 spaces away from the monster.",
        "affinity": "green, blank, blank, blue, blank",
        "bodyPart": "legs",
        "armourPoints": 3,
        "craftLocation": "chorusseum",
        "expansion": "gamblersChest, smogSingers",
    },
    {
        "name": "Hamfluter",
        "keywords": "weapon, melee, club, instrument, noisy",
        "numbers": [2, 6, 3],
        "description": "Ballad of Perfection [7]: Spend Activation and archive 7 cards from the wound stack to perform. All survivors increase their Perfect hit range by 1.",
        "affinityDescription": "redBox blueBox This whistles while you swing. Gain +1 survival and +1 insanity when you attack.",
        "affinity": "red, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "chorusseum",
        "expansion": "gamblersChest, smogSingers",
    },
    {
        "name": "Energy Drum",
        "keywords": "item, instrument, noisy",
        "numbers": null,
        "description": "Activation: Spend 1 survival to play this. An adjacent survivor gains Activation, which they must spend immediately. Limit once per round.",
        "affinity": "blank, blank, blank, blue, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "chorusseum",
        "expansion": "gamblersChest, smogSingers",
    },
    {
        "name": "Peace Dagger",
        "keywords": "weapon, melee, dagger, instrument, noisy",
        "numbers": [3, 6, 2],
        "description": "Ballad of Peace [3]: Spend Activation and archive 3 cards from the wound stack to perform. In the Aftermath. if you did not attack this showdown, gain +1 Endeavor.",
        "affinity": "blue, red, blank, green, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "chorusseum",
        "expansion": "gamblersChest, smogSingers",
    },
    {
        "name": "Harpy Harp",
        "keywords": "item, instrument, noisy",
        "numbers": null,
        "description": "You ignore Overwhielming Darkness",
        "affinityDescription": "redPuzzle greenPuzzle Your noisy weapons gain +1 strength for each instrument in your gear grid.",
        "affinity": "blank, blank, red, green, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "chorusseum",
        "expansion": "gamblersChest, smogSingers",
    },
    {
        "name": "Pipa",
        "keywords": "weapon, melee, club, instrument, noisy",
        "numbers": [2, 6, 0],
        "description": "Ballad of Savagery [6]: Spend Activation and archive 6 cards from the wound stack to perform. All survivors' weapons gain savage.",
        "affinityDescription": "redPuzzle redPuzzle +4 strength",
        "affinity": "red, red, red, red, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "chorusseum",
        "expansion": "gamblersChest, smogSingers",
    },
    {
        "name": "Singing Heart",
        "keywords": "item, lantern, instrument, noisy",
        "numbers": null,
        "description": "The weapon to the left gains noisy and +1 accuracy.",
        "affinityDescription": "redBox greenBox blueBox You may archive this to smash it, creating a vexing wave of white noise. Discard all moods in play. The monster is dazed.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "chorusseum",
        "expansion": "gamblersChest, smogSingers",
    },
    {
        "name": "Razor Cymbals",
        "keywords": "weapon, melee, katar, metal, instrument, noisy",
        "numbers": [2, 6, 4],
        "description": "Paired\nMake attack rolls one at a time. For each hit, the monster suffers -1 evasion until the end of this attack.",
        "affinity": "red, blank, blue, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "chorusseum",
        "expansion": "gamblersChest, smogSingers",
    },
    {
        "name": "Spinning Sword",
        "keywords": "weapon, melee, sword",
        "numbers": [2, 7, 3],
        "description": "Paired\nGain +2 evasion against ranged attacks for each of your Spinning Swords.",
        "affinity": "blank, green, blank, green, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "chorusseum",
        "expansion": "gamblersChest, smogSingers",
    },
    {
        "name": "Spear of Life",
        "keywords": "weapon, melee, spear, two-handed",
        "numbers": [2, 6, 4],
        "description": "Reach 2",
        "affinityDescription": "greenPuzzle When another survivor dies from bleeding tokens, roll 1d10. On a 7+, your dart saves them! They suffer -1 permanent evasion and remove up to 3 bleeding tokens.",
        "affinity": "blank, blank, blank, green, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "chorusseum",
        "expansion": "gamblersChest, smogSingers",
    },
    {
        "name": "Crimson Helm",
        "keywords": "armor, set, bone",
        "numbers": null,
        "description": "Mindlock 1: Spend Activation, you now have exactly 1 mindlock token. When you suffer brain damage, ignore it and lose 1 mindlock token.",
        "affinity": "blank, red, blank, blank, blank",
        "bodyPart": "head",
        "armourPoints": 1,
        "craftLocation": "crimsonCrockery",
        "expansion": "gamblersChest, crimsonCrocodile",
    },
    {
        "name": "Crimson Guard",
        "keywords": "armor, set, flesh",
        "numbers": null,
        "description": "When you depart, a pale scab hardens on your forearm. Gain a bleeding token and add armorPoint1 to the arms hit location.",
        "affinity": "green, blank, blank, red, blank",
        "bodyPart": "arms",
        "armourPoints": 2,
        "craftLocation": "crimsonCrockery",
        "expansion": "gamblersChest, crimsonCrocodile",
    },
    {
        "name": "Crimson Dress",
        "keywords": "armor, set, flesh",
        "numbers": null,
        "description": "Immortal Spin: Spend Movement Activation to move 3 spaces forward. Then if you moved 3 spaces, activate a melee weapon with +1 strength for each bleeding token you have.",
        "affinity": "blank, red, blank, blue, blank",
        "bodyPart": "body",
        "armourPoints": 2,
        "craftLocation": "crimsonCrockery",
        "expansion": "gamblersChest, crimsonCrocodile",
    },
    {
        "name": "Crimson Faulds",
        "keywords": "armor, set, flesh",
        "numbers": null,
        "description": "When you depart, gain a bleeding token.\nIt requires one more bleeding token to kill you.",
        "affinity": "blank, blank, green, blank, blank",
        "bodyPart": "waist",
        "armourPoints": 2,
        "craftLocation": "crimsonCrockery",
        "expansion": "gamblersChest, crimsonCrocodile",
    },
    {
        "name": "Crimson Slippers",
        "keywords": "armor, set, flesh",
        "numbers": null,
        "description": null,
        "affinity": "blank, blank, blank, red, blank",
        "bodyPart": "legs",
        "armourPoints": 2,
        "craftLocation": "crimsonCrockery",
        "expansion": "gamblersChest, crimsonCrocodile",
    },
    {
        "name": "Bloodglass Dagger",
        "keywords": "weapon, melee, dagger, bon",
        "numbers": [3, 6, 0],
        "description": "Honed 3: This has +3 strength until its edge is ruined after wounding a Parry or Super-Dense hit location.",
        "affinity": "blank, red, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "crimsonCrockery",
        "expansion": "gamblersChest, crimsonCrocodile",
    },
    {
        "name": "Crocbone Hammer",
        "keywords": "weapon, melee, club, bone",
        "numbers": [2, 7, 2],
        "description": "Clobber 4: Gain +4 strength while attempting to wound a Super-Dense hit location.",
        "affinity": "blank, red, green, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "crimsonCrockery",
        "expansion": "gamblersChest, crimsonCrocodile",
    },
    {
        "name": "Bloodglass Longsword",
        "keywords": "weapon, melee, sword, two-handed, heavy, bone",
        "numbers": [2, 6, 0],
        "description": "Honed 3, Reach 2",
        "affinityDescription": "redPuzzle bluePuzzle If you have 3+ bleeding tokens, the Honed edge cannot be ruined.",
        "affinity": "blank, blue, blank, red, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "crimsonCrockery",
        "expansion": "gamblersChest, crimsonCrocodile",
    },
    {
        "name": "Blood Compass Lantern",
        "keywords": "item, lantern, other",
        "numbers": null,
        "description": "Before making a wound attempt, you may gain 1 bleeding token to discard all hit locations from your attack and draw that many to replace them. Limit once per round.",
        "affinity": "blank, blue, blue, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "crimsonCrockery",
        "expansion": "gamblersChest, crimsonCrocodile",
    },
    {
        "name": "Crocodileyes",
        "keywords": "item, soluble",
        "numbers": null,
        "description": "Gain starMonsterLevel strength if you have no Foresight.\nForesight: When there are revealed AI Card Icon or hit location cards on top of their deck.",
        "affinity": "red, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "crimsonCrockery",
        "expansion": "gamblersChest, crimsonCrocodile",
    },
    {
        "name": "Crimson Bow",
        "keywords": "weapon, ranged, bow, two-hande",
        "numbers": [2, 6, 3],
        "description": "Cumbersome, Range 5",
        "affinityDescription": "redPuzzle blueBox This gains +2 strength and Deadly while attacking from the monster's facing.",
        "affinity": "blue, red, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "crimsonCrockery",
        "expansion": "gamblersChest, crimsonCrocodile",
    },
    {
        "name": "Finger Darts",
        "keywords": "weapon, ranged, thrown, consumable",
        "numbers": [2, 7, 2],
        "description": "Range 4",
        "affinityDescription": "greenPuzzle bluePuzzle Activation Consume: Devour the scum from under a fingernail to gain starMonsterLevel insanity.",
        "affinity": "blank, green, blank, blue, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "crimsonCrockery",
        "expansion": "gamblersChest, crimsonCrocodile",
    },
    {
        "name": "Bloodglass Cleaver",
        "keywords": "weapon, melee, axe, bone",
        "numbers": [3, 6, 0],
        "description": "Honed 5\nWhile this is equipped, you are guardless.\nGuardless: You cannot dodge or ignore hits.",
        "affinity": "blank, red, red, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "crimsonCrockery",
        "expansion": "gamblersChest, crimsonCrocodile",
    },
    {
        "name": "Bloodglass Katar",
        "keywords": "weapon, melee, katar, bone",
        "numbers": [2, 6, 0],
        "description": "Honed 4, Paired\nWhile you have 3+ bleeding tokens, you gain +2 evasion and are guardless.",
        "affinity": "blank, blank, green, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "crimsonCrockery",
        "expansion": "gamblersChest, crimsonCrocodile",
    },
    {
        "name": "Bloodglass Saw",
        "keywords": "weapon, melee, saw, two-handed, bone",
        "numbers": [2, 7, 0],
        "description": "Honed 3, Savage\nSaw: Spend Movement. For the rest of the round, your attacks with this weapon gain +2 luck.",
        "affinity": "blank, blue, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "crimsonCrockery",
        "expansion": "gamblersChest, crimsonCrocodile",
    },
    {
        "name": "Crimson Pearls",
        "keywords": "item, jewelry, other",
        "numbers": null,
        "description": "On Arrival, gain 3 bleeding tokens.\nYour Fist & Tooth attacks gain +1 strength for each of your bleeding tokens.",
        "affinity": "red, blank, red, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "crimsonCrockery",
        "expansion": "gamblersChest, crimsonCrocodile",
    },
    {
        "name": "Giggling Scythe",
        "keywords": "weapon, melee, grand, scythe, two-handed, bone",
        "numbers": [3, 5, 8],
        "description": "Sharp, Reach 2, Unique\nWhen you critically wound, automatically critically wound all remaining hit locations in your attack.",
        "affinity": "blue, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "crimsonCrockery",
        "expansion": "gamblersChest, crimsonCrocodile",
    },
    {
        "name": "Fortune Lantern Sword",
        "keywords": "weapon, melee, sword, finesse, metal",
        "numbers": [3, 7, 7],
        "description": "Sharp\nDeflect X, where X is equal to the number of reroll tokens you have.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "gamingGazebo",
        "expansion": "gamblersChest",
    },
    {
        "name": "Fortune Lantern Dagger",
        "keywords": "weapon, melee, dagger, finesse, metal",
        "numbers": [4, 9, 4],
        "description": "Sharp, Paired\nDuring a paired attack, if you land 2+ Perfect Hits, gain a reroll token.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "gamingGazebo",
        "expansion": "gamblersChest",
    },
    {
        "name": "Fortune Lantern Helm",
        "keywords": "armor, set, metal, other",
        "numbers": null,
        "description": "Outfit",
        "affinityDescription": "bluePuzzle bluePuzzle On Arrival, gain a reroll token.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": "head",
        "armourPoints": 7,
        "craftLocation": "gamingGazebo",
        "expansion": "gamblersChest",
    },
    {
        "name": "Fortune Lantern Cuirass",
        "keywords": "armor, set, metal, other",
        "numbers": null,
        "description": "Outfit\nOn Arrival, gain a reroll token.\nAt the start of your first act, add 1 to all hit locations for each reroll token you have.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": "body",
        "armourPoints": 7,
        "craftLocation": "gamingGazebo",
        "expansion": "gamblersChest",
    },
    {
        "name": "Gambler's Lantern",
        "keywords": "item, lantern",
        "numbers": null,
        "description": "+1 luck",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "gamingGazebo",
        "expansion": "gamblersChest",
    },
    {
        "name": "Deathking Helm",
        "keywords": "armor, set, deathmetal, heavy",
        "numbers": null,
        "description": "You are the slayer of kings. While insane, you cannot be knocked down.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": "head",
        "armourPoints": 10,
        "craftLocation": "kingsmith",
        "expansion": "gamblersChest, kingThe",
    },
    {
        "name": "Deathking Gauntlets",
        "keywords": "armor, set, deathmetal, heavy",
        "numbers": null,
        "description": "Deflect 1\nBefore drawing hit locations, you may make 1 additional attack roll.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": "arms",
        "armourPoints": 10,
        "craftLocation": "kingsmith",
        "expansion": "gamblersChest, kingThe",
    },
    {
        "name": "Deathking Platemail",
        "keywords": "armor, set, deathmetal, heavy",
        "numbers": null,
        "description": "You are hushed.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": "body",
        "armourPoints": 10,
        "craftLocation": "kingsmith",
        "expansion": "gamblersChest, kingThe",
    },
    {
        "name": "Deathking Greaves",
        "keywords": "armor, set, deathmetal, heavy",
        "numbers": null,
        "description": "Activation: Show off your King's Coin bedazzlement. If you are in the monster's field of view, it is knocked down. Limit once per showdown.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": "waist",
        "armourPoints": 10,
        "craftLocation": "kingsmith",
        "expansion": "gamblersChest, kingThe",
    },
    {
        "name": "Deathking Boots",
        "keywords": "armor, set, deathmetal, heavy",
        "numbers": null,
        "description": "Death Geometry: Spend Movement Movement to place yourself in an unoccupied space adjacent to a monster or survivor. If it is a survivor, you both suffer Monster Level brain damage.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": "legs",
        "armourPoints": 10,
        "craftLocation": "kingsmith",
        "expansion": "gamblersChest, kingThe",
    },
    {
        "name": "Kingslayer",
        "keywords": "weapon, melee, grand, sword, deathmetal, heavy",
        "numbers": [2, 6, 8],
        "description": "Sharp, Refined\nIf you attack from the monster's facing, cancel Reaction on the first selected Monster Hit Location Card.",
        "affinity": "blank, red, blank, blue, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "kingsmith",
        "expansion": "gamblersChest, kingThe",
    },
    {
        "name": "Grand Kingslayer",
        "keywords": "weapon, melee, grand, sword, two-handed, deathmetal, heavy",
        "numbers": [1, 6, 13],
        "description": "Slow, Sharp, Devastating 1\nWhen you critically wound the monster, if you have no armor points and all your injury level boxes are filled in, the monster is slain.",
        "affinity": "blank, blue, red, blue, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "kingsmith",
        "expansion": "gamblersChest, kingThe",
    },
    {
        "name": "Adjudicator",
        "keywords": "weapon, melee, grand, spear, two-handed, deathmetal, heavy",
        "numbers": [2, 6, 14],
        "description": "Reach 2\nIf you draw the Trap with this weapon, you make a preemptive strike! The monster suffers a wound before resolving the Trap.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "kingsmith",
        "expansion": "gamblersChest, kingThe",
    },
    {
        "name": "Usurper",
        "keywords": "weapon, melee, grand, axe, two-handed, deathmetal, heavy",
        "numbers": [2, 6, 14],
        "description": "If you would be knocked down by an adjacent monster, you leverage yourself with the axe. Instead the monster is knocked down and suffers a wound. Limit once per showdown.",
        "affinity": "blank, blank, blank, green, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "kingsmith",
        "expansion": "gamblersChest, kingThe",
    },
    {
        "name": "Assassinator",
        "keywords": "weapon, melee, grand, katar, deathmetal, heavy",
        "numbers": [1, 5, 12],
        "description": "Paired, Barbed 4\nOn a Perfect hit, make additional attack rolls until you miss and gain Deadly 1 until the end of the attack (Deadly 2 if paired). Limit once per attack.",
        "affinity": "blank, blue, blank, red, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "kingsmith",
        "expansion": "gamblersChest, kingThe",
    },
    {
        "name": "Royal Shield",
        "keywords": "weapon, melee, grand, shield, deathmetal, heavy",
        "numbers": [1, 7, 8],
        "description": "Add armorPoint3 to all hit locations.",
        "affinityDescription": "redBox greenBox After you attack with the weapon to the left of this, Deflect 2 for free.",
        "affinity": "blank, green, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "kingsmith",
        "expansion": "gamblersChest, kingThe",
    },
    {
        "name": "Royal Medallion",
        "keywords": "item, deathmetal, other",
        "numbers": null,
        "description": "At the start of each round, lose 3 survival and gain the priority target token.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "kingsmith",
        "expansion": "gamblersChest, kingThe",
    },
    {
        "name": "Royal Lantern",
        "keywords": "item, lantern, deathmetal, other",
        "numbers": null,
        "description": "The monster starts 2 spaces closer to the Start space on the hunt board.",
        "affinity": "blue, blank, red, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "kingsmith",
        "expansion": "gamblersChest, kingThe",
    },
    {
        "name": "Stone Face Cloak",
        "keywords": "armor, scout, heavy, stone",
        "numbers": null,
        "description": "At the start of your act, if you are not on terrain, you may hide. Replace yourself with the Hidden Face terrain tile. Place the Scout miniature on the terrain card.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": ["head", "body"],
        "armourPoints": 2,
        "craftLocation": "outskirts",
        "expansion": "gamblersChest, outskirts",
    },
    {
        "name": "Vermin Bellyboots",
        "keywords": "armor, scout",
        "numbers": null,
        "description": "+1 movement\nWhen the monster has another eligible target, it will always pick them first.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": "legs",
        "armourPoints": 2,
        "craftLocation": "outskirts",
        "expansion": "gamblersChest, outskirts",
    },
    {
        "name": "Grimjaw",
        "keywords": "weapon, scout, melee, dagger, finesse, metal",
        "numbers": [3, 5, 4],
        "description": "During the Aftermath, if you wounded the monster at least once, gain +1 monster resource card.",
        "affinityDescription": "redPuzzle bluePuzzle Barbed 6",
        "affinity": "blank, red, blue, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "outskirts",
        "expansion": "gamblersChest, outskirts",
    },
    {
        "name": "Scout's Lantern",
        "keywords": "item, scout, lantern, fragile",
        "numbers": null,
        "description": "When you return to the settlement, draw 2 settlementEvent and pick 1 to keep this lantern year.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "outskirts",
        "expansion": "gamblersChest, outskirts",
    },
    {
        "name": "Hunting Salve",
        "keywords": "item, scout, soluble",
        "numbers": null,
        "description": "After revealing a hunt event card, you may archive this to skip it.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "outskirts",
        "expansion": "gamblersChest, outskirts",
    },
    {
        "name": "Blood Pack",
        "keywords": "item, scout, fragile",
        "numbers": null,
        "description": "During the Aftermath, if another survivor died from bleeding tokens, archive this and roll 1d10. On a 7+, they live!",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "outskirts",
        "expansion": "gamblersChest, outskirts",
    },
    {
        "name": "Disguise Kit",
        "keywords": "item, scout, balm, soluble",
        "numbers": null,
        "description": "After resolving a hunt event or encounter in which a survivor died, you dramatically reveal yourself! The scout dies instead of that survivor.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "outskirts",
        "expansion": "gamblersChest, outskirts",
    },
    {
        "name": "Scout Whistle",
        "keywords": "item, scout, instrument, noisy",
        "numbers": null,
        "description": "At the start of the round, you may roll 1d10. On a 3+, gain the priority target token. Limit once per showdown.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "outskirts",
        "expansion": "gamblersChest, outskirts",
    },
    {
        "name": "Glyph Sword",
        "keywords": "weapon, melee, sword, deathmetal, other",
        "numbers": [3, 6, 18],
        "description": "Cursed, Unique\nThe first time you would with this each showdown, the weapon's bloodlust rouses. Gain Disorder Immortal and +1d1000 insanity",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "glyph",
        "expansion": "gamblersChest, kingThe",
    },
    {
        "name": "Glyph Katana",
        "keywords": "weapon, melee, grand, katana, heavy, deathmetal, other",
        "numbers": [3, 6, 12],
        "description": "Sharp, Unique\nAt the end of your attack, if you wounded the monster, ruleBook Great Divide",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "glyph",
        "expansion": "gamblersChest, kingThe",
    },
    {
        "name": "Glyph Club",
        "keywords": "weapon, melee, grand, club, heavy, deathmetal, other",
        "numbers": [1, 6, 17],
        "description": "Slow, Surpass 5\nThe first time you surpass with this each showdown, the monster is knocked down and ignores Indomitable this round.",
        "affinity": "blank, green, blue, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "glyph",
        "expansion": "gamblersChest, kingThe",
    },
    {
        "name": "Glyph Spear",
        "keywords": "weapon, melee, grand, spear, heavy, deathmetal, other",
        "numbers": [2, 6, 10],
        "description": "Reach 2, Sharp\nWhen you hit with this, draw hitLocation from the discard pile. Suffer 2 brain damage for each hit. If you need to draw more cards than are discarded, the spear devours you. Dead.",
        "affinity": "blank, blank, blank, blank, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "glyph",
        "expansion": "gamblersChest, kingThe",
    },
    {
        "name": "Glyph Whip",
        "keywords": "weapon, melee, grand, whip, dagger, heavy, deathmetal, other",
        "numbers": [2, 7, 12],
        "description": "Reach 3, Deadly, Unique\nWhen you draw hitLocation without a critical wound, draw a glyphMonsterCard and add its critical wound effect to this hitLocation.",
        "affinity": "blank, blank, blue, red, blank",
        "bodyPart": null,
        "armourPoints": null,
        "craftLocation": "glyph",
        "expansion": "gamblersChest, kingThe",
    },

    
    
];


export default gearCards;